var map = {
	"./": [
		18912,
		9,
		57446,
		18912
	],
	"./_lib/buildFormatLongFn": [
		96371,
		7,
		96371
	],
	"./_lib/buildFormatLongFn/": [
		96371,
		7,
		96371
	],
	"./_lib/buildFormatLongFn/index": [
		96371,
		7,
		96371
	],
	"./_lib/buildFormatLongFn/index.js": [
		96371,
		7,
		96371
	],
	"./_lib/buildLocalizeFn": [
		1725,
		7,
		1725
	],
	"./_lib/buildLocalizeFn/": [
		1725,
		7,
		1725
	],
	"./_lib/buildLocalizeFn/index": [
		1725,
		7,
		1725
	],
	"./_lib/buildLocalizeFn/index.js": [
		1725,
		7,
		1725
	],
	"./_lib/buildMatchFn": [
		1087,
		7,
		1087
	],
	"./_lib/buildMatchFn/": [
		1087,
		7,
		1087
	],
	"./_lib/buildMatchFn/index": [
		1087,
		7,
		1087
	],
	"./_lib/buildMatchFn/index.js": [
		1087,
		7,
		1087
	],
	"./_lib/buildMatchPatternFn": [
		17512,
		7,
		17512
	],
	"./_lib/buildMatchPatternFn/": [
		17512,
		7,
		17512
	],
	"./_lib/buildMatchPatternFn/index": [
		17512,
		7,
		17512
	],
	"./_lib/buildMatchPatternFn/index.js": [
		17512,
		7,
		17512
	],
	"./af": [
		5821,
		9,
		5821
	],
	"./af/": [
		5821,
		9,
		5821
	],
	"./af/_lib/formatDistance": [
		77472,
		7,
		77472
	],
	"./af/_lib/formatDistance/": [
		77472,
		7,
		77472
	],
	"./af/_lib/formatDistance/index": [
		77472,
		7,
		77472
	],
	"./af/_lib/formatDistance/index.js": [
		77472,
		7,
		77472
	],
	"./af/_lib/formatLong": [
		10049,
		7,
		10049
	],
	"./af/_lib/formatLong/": [
		10049,
		7,
		10049
	],
	"./af/_lib/formatLong/index": [
		10049,
		7,
		10049
	],
	"./af/_lib/formatLong/index.js": [
		10049,
		7,
		10049
	],
	"./af/_lib/formatRelative": [
		90983,
		7,
		90983
	],
	"./af/_lib/formatRelative/": [
		90983,
		7,
		90983
	],
	"./af/_lib/formatRelative/index": [
		90983,
		7,
		90983
	],
	"./af/_lib/formatRelative/index.js": [
		90983,
		7,
		90983
	],
	"./af/_lib/localize": [
		89191,
		7,
		89191
	],
	"./af/_lib/localize/": [
		89191,
		7,
		89191
	],
	"./af/_lib/localize/index": [
		89191,
		7,
		89191
	],
	"./af/_lib/localize/index.js": [
		89191,
		7,
		89191
	],
	"./af/_lib/match": [
		25687,
		7,
		25687
	],
	"./af/_lib/match/": [
		25687,
		7,
		25687
	],
	"./af/_lib/match/index": [
		25687,
		7,
		25687
	],
	"./af/_lib/match/index.js": [
		25687,
		7,
		25687
	],
	"./af/index": [
		25581,
		7,
		25581
	],
	"./af/index.d": [
		26797,
		9,
		26797
	],
	"./af/index.d.ts": [
		26797,
		9,
		26797
	],
	"./af/index.js": [
		25581,
		7,
		25581
	],
	"./af/index.js.flow": [
		59472,
		1,
		59472
	],
	"./af/package": [
		20138,
		3,
		20138
	],
	"./af/package.json": [
		20138,
		3,
		20138
	],
	"./ar-DZ": [
		61548,
		9,
		61548
	],
	"./ar-DZ/": [
		61548,
		9,
		61548
	],
	"./ar-DZ/_lib/formatDistance": [
		44243,
		7,
		44243
	],
	"./ar-DZ/_lib/formatDistance/": [
		44243,
		7,
		44243
	],
	"./ar-DZ/_lib/formatDistance/index": [
		44243,
		7,
		44243
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		44243,
		7,
		44243
	],
	"./ar-DZ/_lib/formatLong": [
		57979,
		7,
		57979
	],
	"./ar-DZ/_lib/formatLong/": [
		57979,
		7,
		57979
	],
	"./ar-DZ/_lib/formatLong/index": [
		57979,
		7,
		57979
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		57979,
		7,
		57979
	],
	"./ar-DZ/_lib/formatRelative": [
		10129,
		7,
		10129
	],
	"./ar-DZ/_lib/formatRelative/": [
		10129,
		7,
		10129
	],
	"./ar-DZ/_lib/formatRelative/index": [
		10129,
		7,
		10129
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		10129,
		7,
		10129
	],
	"./ar-DZ/_lib/localize": [
		75667,
		7,
		75667
	],
	"./ar-DZ/_lib/localize/": [
		75667,
		7,
		75667
	],
	"./ar-DZ/_lib/localize/index": [
		75667,
		7,
		75667
	],
	"./ar-DZ/_lib/localize/index.js": [
		75667,
		7,
		75667
	],
	"./ar-DZ/_lib/match": [
		22934,
		7,
		22934
	],
	"./ar-DZ/_lib/match/": [
		22934,
		7,
		22934
	],
	"./ar-DZ/_lib/match/index": [
		22934,
		7,
		22934
	],
	"./ar-DZ/_lib/match/index.js": [
		22934,
		7,
		22934
	],
	"./ar-DZ/index": [
		12094,
		7,
		12094
	],
	"./ar-DZ/index.d": [
		30742,
		9,
		30742
	],
	"./ar-DZ/index.d.ts": [
		30742,
		9,
		30742
	],
	"./ar-DZ/index.js": [
		12094,
		7,
		12094
	],
	"./ar-DZ/index.js.flow": [
		81753,
		1,
		81753
	],
	"./ar-DZ/package": [
		26890,
		3,
		26890
	],
	"./ar-DZ/package.json": [
		26890,
		3,
		26890
	],
	"./ar-MA": [
		2005,
		9,
		2005
	],
	"./ar-MA/": [
		2005,
		9,
		2005
	],
	"./ar-MA/_lib/formatDistance": [
		39862,
		7,
		23926
	],
	"./ar-MA/_lib/formatDistance/": [
		39862,
		7,
		23926
	],
	"./ar-MA/_lib/formatDistance/index": [
		39862,
		7,
		23926
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		39862,
		7,
		23926
	],
	"./ar-MA/_lib/formatLong": [
		88635,
		7,
		88635
	],
	"./ar-MA/_lib/formatLong/": [
		88635,
		7,
		88635
	],
	"./ar-MA/_lib/formatLong/index": [
		88635,
		7,
		88635
	],
	"./ar-MA/_lib/formatLong/index.js": [
		88635,
		7,
		88635
	],
	"./ar-MA/_lib/formatRelative": [
		88493,
		7,
		88493
	],
	"./ar-MA/_lib/formatRelative/": [
		88493,
		7,
		88493
	],
	"./ar-MA/_lib/formatRelative/index": [
		88493,
		7,
		88493
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		88493,
		7,
		88493
	],
	"./ar-MA/_lib/localize": [
		13341,
		7,
		13341
	],
	"./ar-MA/_lib/localize/": [
		13341,
		7,
		13341
	],
	"./ar-MA/_lib/localize/index": [
		13341,
		7,
		13341
	],
	"./ar-MA/_lib/localize/index.js": [
		13341,
		7,
		13341
	],
	"./ar-MA/_lib/match": [
		75681,
		7,
		75681
	],
	"./ar-MA/_lib/match/": [
		75681,
		7,
		75681
	],
	"./ar-MA/_lib/match/index": [
		75681,
		7,
		75681
	],
	"./ar-MA/_lib/match/index.js": [
		75681,
		7,
		75681
	],
	"./ar-MA/index": [
		66005,
		7,
		66005
	],
	"./ar-MA/index.d": [
		38711,
		9,
		38711
	],
	"./ar-MA/index.d.ts": [
		38711,
		9,
		38711
	],
	"./ar-MA/index.js": [
		66005,
		7,
		66005
	],
	"./ar-MA/index.js.flow": [
		77593,
		1,
		77593
	],
	"./ar-MA/package": [
		7623,
		3,
		7623
	],
	"./ar-MA/package.json": [
		7623,
		3,
		7623
	],
	"./ar-SA": [
		21290,
		9,
		21290
	],
	"./ar-SA/": [
		21290,
		9,
		21290
	],
	"./ar-SA/_lib/formatDistance": [
		95891,
		7,
		95891
	],
	"./ar-SA/_lib/formatDistance/": [
		95891,
		7,
		95891
	],
	"./ar-SA/_lib/formatDistance/index": [
		95891,
		7,
		95891
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		95891,
		7,
		95891
	],
	"./ar-SA/_lib/formatLong": [
		36373,
		7,
		36373
	],
	"./ar-SA/_lib/formatLong/": [
		36373,
		7,
		36373
	],
	"./ar-SA/_lib/formatLong/index": [
		36373,
		7,
		36373
	],
	"./ar-SA/_lib/formatLong/index.js": [
		36373,
		7,
		36373
	],
	"./ar-SA/_lib/formatRelative": [
		45249,
		7,
		45249
	],
	"./ar-SA/_lib/formatRelative/": [
		45249,
		7,
		45249
	],
	"./ar-SA/_lib/formatRelative/index": [
		45249,
		7,
		45249
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		45249,
		7,
		45249
	],
	"./ar-SA/_lib/localize": [
		69638,
		7,
		69638
	],
	"./ar-SA/_lib/localize/": [
		69638,
		7,
		69638
	],
	"./ar-SA/_lib/localize/index": [
		69638,
		7,
		69638
	],
	"./ar-SA/_lib/localize/index.js": [
		69638,
		7,
		69638
	],
	"./ar-SA/_lib/match": [
		17911,
		7,
		17911
	],
	"./ar-SA/_lib/match/": [
		17911,
		7,
		17911
	],
	"./ar-SA/_lib/match/index": [
		17911,
		7,
		17911
	],
	"./ar-SA/_lib/match/index.js": [
		17911,
		7,
		17911
	],
	"./ar-SA/index": [
		75686,
		7,
		75686
	],
	"./ar-SA/index.d": [
		48159,
		9,
		48159
	],
	"./ar-SA/index.d.ts": [
		48159,
		9,
		48159
	],
	"./ar-SA/index.js": [
		75686,
		7,
		75686
	],
	"./ar-SA/index.js.flow": [
		11144,
		1,
		11144
	],
	"./ar-SA/package": [
		26905,
		3,
		26905
	],
	"./ar-SA/package.json": [
		26905,
		3,
		26905
	],
	"./az": [
		20221,
		9,
		20221
	],
	"./az/": [
		20221,
		9,
		20221
	],
	"./az/_lib/formatDistance": [
		80070,
		7,
		80070
	],
	"./az/_lib/formatDistance/": [
		80070,
		7,
		80070
	],
	"./az/_lib/formatDistance/index": [
		80070,
		7,
		80070
	],
	"./az/_lib/formatDistance/index.js": [
		80070,
		7,
		80070
	],
	"./az/_lib/formatLong": [
		7202,
		7,
		7202
	],
	"./az/_lib/formatLong/": [
		7202,
		7,
		7202
	],
	"./az/_lib/formatLong/index": [
		7202,
		7,
		7202
	],
	"./az/_lib/formatLong/index.js": [
		7202,
		7,
		7202
	],
	"./az/_lib/formatRelative": [
		50003,
		7,
		50003
	],
	"./az/_lib/formatRelative/": [
		50003,
		7,
		50003
	],
	"./az/_lib/formatRelative/index": [
		50003,
		7,
		50003
	],
	"./az/_lib/formatRelative/index.js": [
		50003,
		7,
		50003
	],
	"./az/_lib/localize": [
		61038,
		7,
		61038
	],
	"./az/_lib/localize/": [
		61038,
		7,
		61038
	],
	"./az/_lib/localize/index": [
		61038,
		7,
		61038
	],
	"./az/_lib/localize/index.js": [
		61038,
		7,
		61038
	],
	"./az/_lib/match": [
		20404,
		7,
		20404
	],
	"./az/_lib/match/": [
		20404,
		7,
		20404
	],
	"./az/_lib/match/index": [
		20404,
		7,
		20404
	],
	"./az/_lib/match/index.js": [
		20404,
		7,
		20404
	],
	"./az/index": [
		26233,
		7,
		26233
	],
	"./az/index.d": [
		37595,
		9,
		37595
	],
	"./az/index.d.ts": [
		37595,
		9,
		37595
	],
	"./az/index.js": [
		26233,
		7,
		26233
	],
	"./az/index.js.flow": [
		78457,
		1,
		78457
	],
	"./az/package": [
		96713,
		3,
		96713
	],
	"./az/package.json": [
		96713,
		3,
		96713
	],
	"./be": [
		57446,
		9,
		57446
	],
	"./be/": [
		57446,
		9,
		57446
	],
	"./be/_lib/formatDistance": [
		22406,
		7,
		22406
	],
	"./be/_lib/formatDistance/": [
		22406,
		7,
		22406
	],
	"./be/_lib/formatDistance/index": [
		22406,
		7,
		22406
	],
	"./be/_lib/formatDistance/index.js": [
		22406,
		7,
		22406
	],
	"./be/_lib/formatLong": [
		13032,
		7,
		13032
	],
	"./be/_lib/formatLong/": [
		13032,
		7,
		13032
	],
	"./be/_lib/formatLong/index": [
		13032,
		7,
		13032
	],
	"./be/_lib/formatLong/index.js": [
		13032,
		7,
		13032
	],
	"./be/_lib/formatRelative": [
		73720,
		7,
		73720
	],
	"./be/_lib/formatRelative/": [
		73720,
		7,
		73720
	],
	"./be/_lib/formatRelative/index": [
		73720,
		7,
		73720
	],
	"./be/_lib/formatRelative/index.js": [
		73720,
		7,
		73720
	],
	"./be/_lib/localize": [
		8133,
		7,
		8133
	],
	"./be/_lib/localize/": [
		8133,
		7,
		8133
	],
	"./be/_lib/localize/index": [
		8133,
		7,
		8133
	],
	"./be/_lib/localize/index.js": [
		8133,
		7,
		8133
	],
	"./be/_lib/match": [
		58884,
		7,
		58884
	],
	"./be/_lib/match/": [
		58884,
		7,
		58884
	],
	"./be/_lib/match/index": [
		58884,
		7,
		58884
	],
	"./be/_lib/match/index.js": [
		58884,
		7,
		58884
	],
	"./be/index": [
		73519,
		7,
		73519
	],
	"./be/index.d": [
		41663,
		9,
		57446,
		41663
	],
	"./be/index.d.ts": [
		41663,
		9,
		57446,
		41663
	],
	"./be/index.js": [
		73519,
		7,
		73519
	],
	"./be/index.js.flow": [
		96781,
		1,
		96781
	],
	"./be/package": [
		70136,
		3,
		70136
	],
	"./be/package.json": [
		70136,
		3,
		70136
	],
	"./bg": [
		97817,
		9,
		97817
	],
	"./bg/": [
		97817,
		9,
		97817
	],
	"./bg/_lib/formatDistance": [
		81654,
		7,
		81654
	],
	"./bg/_lib/formatDistance/": [
		81654,
		7,
		81654
	],
	"./bg/_lib/formatDistance/index": [
		81654,
		7,
		81654
	],
	"./bg/_lib/formatDistance/index.js": [
		81654,
		7,
		81654
	],
	"./bg/_lib/formatLong": [
		94381,
		7,
		94381
	],
	"./bg/_lib/formatLong/": [
		94381,
		7,
		94381
	],
	"./bg/_lib/formatLong/index": [
		94381,
		7,
		94381
	],
	"./bg/_lib/formatLong/index.js": [
		94381,
		7,
		94381
	],
	"./bg/_lib/formatRelative": [
		31834,
		7,
		31834
	],
	"./bg/_lib/formatRelative/": [
		31834,
		7,
		31834
	],
	"./bg/_lib/formatRelative/index": [
		31834,
		7,
		31834
	],
	"./bg/_lib/formatRelative/index.js": [
		31834,
		7,
		31834
	],
	"./bg/_lib/localize": [
		29464,
		7,
		29464
	],
	"./bg/_lib/localize/": [
		29464,
		7,
		29464
	],
	"./bg/_lib/localize/index": [
		29464,
		7,
		29464
	],
	"./bg/_lib/localize/index.js": [
		29464,
		7,
		29464
	],
	"./bg/_lib/match": [
		7094,
		7,
		7094
	],
	"./bg/_lib/match/": [
		7094,
		7,
		7094
	],
	"./bg/_lib/match/index": [
		7094,
		7,
		7094
	],
	"./bg/_lib/match/index.js": [
		7094,
		7,
		7094
	],
	"./bg/index": [
		40519,
		7,
		40519
	],
	"./bg/index.d": [
		43668,
		9,
		43668
	],
	"./bg/index.d.ts": [
		43668,
		9,
		43668
	],
	"./bg/index.js": [
		40519,
		7,
		40519
	],
	"./bg/index.js.flow": [
		90656,
		1,
		90656
	],
	"./bg/package": [
		63986,
		3,
		63986
	],
	"./bg/package.json": [
		63986,
		3,
		63986
	],
	"./bn": [
		81051,
		9,
		81051
	],
	"./bn/": [
		81051,
		9,
		81051
	],
	"./bn/_lib/formatDistance": [
		80951,
		7,
		80951
	],
	"./bn/_lib/formatDistance/": [
		80951,
		7,
		80951
	],
	"./bn/_lib/formatDistance/index": [
		80951,
		7,
		80951
	],
	"./bn/_lib/formatDistance/index.js": [
		80951,
		7,
		80951
	],
	"./bn/_lib/formatLong": [
		90013,
		7,
		90013
	],
	"./bn/_lib/formatLong/": [
		90013,
		7,
		90013
	],
	"./bn/_lib/formatLong/index": [
		90013,
		7,
		90013
	],
	"./bn/_lib/formatLong/index.js": [
		90013,
		7,
		90013
	],
	"./bn/_lib/formatRelative": [
		23213,
		7,
		23213
	],
	"./bn/_lib/formatRelative/": [
		23213,
		7,
		23213
	],
	"./bn/_lib/formatRelative/index": [
		23213,
		7,
		23213
	],
	"./bn/_lib/formatRelative/index.js": [
		23213,
		7,
		23213
	],
	"./bn/_lib/localize": [
		75689,
		7,
		75689
	],
	"./bn/_lib/localize/": [
		75689,
		7,
		75689
	],
	"./bn/_lib/localize/index": [
		75689,
		7,
		75689
	],
	"./bn/_lib/localize/index.js": [
		75689,
		7,
		75689
	],
	"./bn/_lib/match": [
		47373,
		7,
		47373
	],
	"./bn/_lib/match/": [
		47373,
		7,
		47373
	],
	"./bn/_lib/match/index": [
		47373,
		7,
		47373
	],
	"./bn/_lib/match/index.js": [
		47373,
		7,
		47373
	],
	"./bn/index": [
		54164,
		7,
		54164
	],
	"./bn/index.d": [
		76627,
		9,
		76627
	],
	"./bn/index.d.ts": [
		76627,
		9,
		76627
	],
	"./bn/index.js": [
		54164,
		7,
		54164
	],
	"./bn/index.js.flow": [
		4673,
		1,
		4673
	],
	"./bn/package": [
		9958,
		3,
		9958
	],
	"./bn/package.json": [
		9958,
		3,
		9958
	],
	"./ca": [
		82364,
		9,
		82364
	],
	"./ca/": [
		82364,
		9,
		82364
	],
	"./ca/_lib/formatDistance": [
		52081,
		7,
		52081
	],
	"./ca/_lib/formatDistance/": [
		52081,
		7,
		52081
	],
	"./ca/_lib/formatDistance/index": [
		52081,
		7,
		52081
	],
	"./ca/_lib/formatDistance/index.js": [
		52081,
		7,
		52081
	],
	"./ca/_lib/formatLong": [
		18051,
		7,
		18051
	],
	"./ca/_lib/formatLong/": [
		18051,
		7,
		18051
	],
	"./ca/_lib/formatLong/index": [
		18051,
		7,
		18051
	],
	"./ca/_lib/formatLong/index.js": [
		18051,
		7,
		18051
	],
	"./ca/_lib/formatRelative": [
		67680,
		7,
		67680
	],
	"./ca/_lib/formatRelative/": [
		67680,
		7,
		67680
	],
	"./ca/_lib/formatRelative/index": [
		67680,
		7,
		67680
	],
	"./ca/_lib/formatRelative/index.js": [
		67680,
		7,
		67680
	],
	"./ca/_lib/localize": [
		1651,
		7,
		1651
	],
	"./ca/_lib/localize/": [
		1651,
		7,
		1651
	],
	"./ca/_lib/localize/index": [
		1651,
		7,
		1651
	],
	"./ca/_lib/localize/index.js": [
		1651,
		7,
		1651
	],
	"./ca/_lib/match": [
		90820,
		7,
		90820
	],
	"./ca/_lib/match/": [
		90820,
		7,
		90820
	],
	"./ca/_lib/match/index": [
		90820,
		7,
		90820
	],
	"./ca/_lib/match/index.js": [
		90820,
		7,
		90820
	],
	"./ca/index": [
		68627,
		7,
		68627
	],
	"./ca/index.d": [
		66122,
		9,
		66122
	],
	"./ca/index.d.ts": [
		66122,
		9,
		66122
	],
	"./ca/index.js": [
		68627,
		7,
		68627
	],
	"./ca/index.js.flow": [
		24722,
		1,
		24722
	],
	"./ca/package": [
		39609,
		3,
		39609
	],
	"./ca/package.json": [
		39609,
		3,
		39609
	],
	"./cs": [
		87952,
		9,
		87952
	],
	"./cs/": [
		87952,
		9,
		87952
	],
	"./cs/_lib/formatDistance": [
		22370,
		7,
		22370
	],
	"./cs/_lib/formatDistance/": [
		22370,
		7,
		22370
	],
	"./cs/_lib/formatDistance/index": [
		22370,
		7,
		22370
	],
	"./cs/_lib/formatDistance/index.js": [
		22370,
		7,
		22370
	],
	"./cs/_lib/formatLong": [
		64230,
		7,
		64230
	],
	"./cs/_lib/formatLong/": [
		64230,
		7,
		64230
	],
	"./cs/_lib/formatLong/index": [
		64230,
		7,
		64230
	],
	"./cs/_lib/formatLong/index.js": [
		64230,
		7,
		64230
	],
	"./cs/_lib/formatRelative": [
		53431,
		7,
		53431
	],
	"./cs/_lib/formatRelative/": [
		53431,
		7,
		53431
	],
	"./cs/_lib/formatRelative/index": [
		53431,
		7,
		53431
	],
	"./cs/_lib/formatRelative/index.js": [
		53431,
		7,
		53431
	],
	"./cs/_lib/localize": [
		25953,
		7,
		25953
	],
	"./cs/_lib/localize/": [
		25953,
		7,
		25953
	],
	"./cs/_lib/localize/index": [
		25953,
		7,
		25953
	],
	"./cs/_lib/localize/index.js": [
		25953,
		7,
		25953
	],
	"./cs/_lib/match": [
		1316,
		7,
		1316
	],
	"./cs/_lib/match/": [
		1316,
		7,
		1316
	],
	"./cs/_lib/match/index": [
		1316,
		7,
		1316
	],
	"./cs/_lib/match/index.js": [
		1316,
		7,
		1316
	],
	"./cs/index": [
		77193,
		7,
		77193
	],
	"./cs/index.d": [
		28969,
		9,
		28969
	],
	"./cs/index.d.ts": [
		28969,
		9,
		28969
	],
	"./cs/index.js": [
		77193,
		7,
		77193
	],
	"./cs/index.js.flow": [
		31220,
		1,
		31220
	],
	"./cs/package": [
		81630,
		3,
		81630
	],
	"./cs/package.json": [
		81630,
		3,
		81630
	],
	"./cy": [
		10103,
		9,
		10103
	],
	"./cy/": [
		10103,
		9,
		10103
	],
	"./cy/_lib/formatDistance": [
		31688,
		7,
		31688
	],
	"./cy/_lib/formatDistance/": [
		31688,
		7,
		31688
	],
	"./cy/_lib/formatDistance/index": [
		31688,
		7,
		31688
	],
	"./cy/_lib/formatDistance/index.js": [
		31688,
		7,
		31688
	],
	"./cy/_lib/formatLong": [
		63297,
		7,
		63297
	],
	"./cy/_lib/formatLong/": [
		63297,
		7,
		63297
	],
	"./cy/_lib/formatLong/index": [
		63297,
		7,
		63297
	],
	"./cy/_lib/formatLong/index.js": [
		63297,
		7,
		63297
	],
	"./cy/_lib/formatRelative": [
		99256,
		7,
		99256
	],
	"./cy/_lib/formatRelative/": [
		99256,
		7,
		99256
	],
	"./cy/_lib/formatRelative/index": [
		99256,
		7,
		99256
	],
	"./cy/_lib/formatRelative/index.js": [
		99256,
		7,
		99256
	],
	"./cy/_lib/localize": [
		84591,
		7,
		84591
	],
	"./cy/_lib/localize/": [
		84591,
		7,
		84591
	],
	"./cy/_lib/localize/index": [
		84591,
		7,
		84591
	],
	"./cy/_lib/localize/index.js": [
		84591,
		7,
		84591
	],
	"./cy/_lib/match": [
		57193,
		7,
		57193
	],
	"./cy/_lib/match/": [
		57193,
		7,
		57193
	],
	"./cy/_lib/match/index": [
		57193,
		7,
		57193
	],
	"./cy/_lib/match/index.js": [
		57193,
		7,
		57193
	],
	"./cy/index": [
		10152,
		7,
		10152
	],
	"./cy/index.d": [
		54055,
		9,
		38628
	],
	"./cy/index.d.ts": [
		54055,
		9,
		38628
	],
	"./cy/index.js": [
		10152,
		7,
		10152
	],
	"./cy/index.js.flow": [
		97305,
		1,
		97305
	],
	"./cy/package": [
		5912,
		3,
		5912
	],
	"./cy/package.json": [
		5912,
		3,
		5912
	],
	"./da": [
		48592,
		9,
		48592
	],
	"./da/": [
		48592,
		9,
		48592
	],
	"./da/_lib/formatDistance": [
		86529,
		7,
		86529
	],
	"./da/_lib/formatDistance/": [
		86529,
		7,
		86529
	],
	"./da/_lib/formatDistance/index": [
		86529,
		7,
		86529
	],
	"./da/_lib/formatDistance/index.js": [
		86529,
		7,
		86529
	],
	"./da/_lib/formatLong": [
		65868,
		7,
		65868
	],
	"./da/_lib/formatLong/": [
		65868,
		7,
		65868
	],
	"./da/_lib/formatLong/index": [
		65868,
		7,
		65868
	],
	"./da/_lib/formatLong/index.js": [
		65868,
		7,
		65868
	],
	"./da/_lib/formatRelative": [
		39651,
		7,
		39651
	],
	"./da/_lib/formatRelative/": [
		39651,
		7,
		39651
	],
	"./da/_lib/formatRelative/index": [
		39651,
		7,
		39651
	],
	"./da/_lib/formatRelative/index.js": [
		39651,
		7,
		39651
	],
	"./da/_lib/localize": [
		31053,
		7,
		31053
	],
	"./da/_lib/localize/": [
		31053,
		7,
		31053
	],
	"./da/_lib/localize/index": [
		31053,
		7,
		31053
	],
	"./da/_lib/localize/index.js": [
		31053,
		7,
		31053
	],
	"./da/_lib/match": [
		38447,
		7,
		38447
	],
	"./da/_lib/match/": [
		38447,
		7,
		38447
	],
	"./da/_lib/match/index": [
		38447,
		7,
		38447
	],
	"./da/_lib/match/index.js": [
		38447,
		7,
		38447
	],
	"./da/index": [
		48127,
		7,
		48127
	],
	"./da/index.d": [
		1931,
		9,
		1931
	],
	"./da/index.d.ts": [
		1931,
		9,
		1931
	],
	"./da/index.js": [
		48127,
		7,
		48127
	],
	"./da/index.js.flow": [
		32166,
		1,
		32166
	],
	"./da/package": [
		2897,
		3,
		2897
	],
	"./da/package.json": [
		2897,
		3,
		2897
	],
	"./de": [
		52263,
		9,
		52263
	],
	"./de-AT": [
		63303,
		9,
		63303
	],
	"./de-AT/": [
		63303,
		9,
		63303
	],
	"./de-AT/_lib/localize": [
		46413,
		7,
		46413
	],
	"./de-AT/_lib/localize/": [
		46413,
		7,
		46413
	],
	"./de-AT/_lib/localize/index": [
		46413,
		7,
		46413
	],
	"./de-AT/_lib/localize/index.js": [
		46413,
		7,
		46413
	],
	"./de-AT/index": [
		55324,
		7,
		55324
	],
	"./de-AT/index.d": [
		79569,
		9,
		79569
	],
	"./de-AT/index.d.ts": [
		79569,
		9,
		79569
	],
	"./de-AT/index.js": [
		55324,
		7,
		55324
	],
	"./de-AT/index.js.flow": [
		37610,
		1,
		37610
	],
	"./de-AT/package": [
		66159,
		3,
		66159
	],
	"./de-AT/package.json": [
		66159,
		3,
		66159
	],
	"./de/": [
		52263,
		9,
		52263
	],
	"./de/_lib/formatDistance": [
		31133,
		7,
		31133
	],
	"./de/_lib/formatDistance/": [
		31133,
		7,
		31133
	],
	"./de/_lib/formatDistance/index": [
		31133,
		7,
		31133
	],
	"./de/_lib/formatDistance/index.js": [
		31133,
		7,
		31133
	],
	"./de/_lib/formatLong": [
		9567,
		7,
		9567
	],
	"./de/_lib/formatLong/": [
		9567,
		7,
		9567
	],
	"./de/_lib/formatLong/index": [
		9567,
		7,
		9567
	],
	"./de/_lib/formatLong/index.js": [
		9567,
		7,
		9567
	],
	"./de/_lib/formatRelative": [
		9147,
		7,
		9147
	],
	"./de/_lib/formatRelative/": [
		9147,
		7,
		9147
	],
	"./de/_lib/formatRelative/index": [
		9147,
		7,
		9147
	],
	"./de/_lib/formatRelative/index.js": [
		9147,
		7,
		9147
	],
	"./de/_lib/localize": [
		95298,
		7,
		95298
	],
	"./de/_lib/localize/": [
		95298,
		7,
		95298
	],
	"./de/_lib/localize/index": [
		95298,
		7,
		95298
	],
	"./de/_lib/localize/index.js": [
		95298,
		7,
		95298
	],
	"./de/_lib/match": [
		24521,
		7,
		24521
	],
	"./de/_lib/match/": [
		24521,
		7,
		24521
	],
	"./de/_lib/match/index": [
		24521,
		7,
		24521
	],
	"./de/_lib/match/index.js": [
		24521,
		7,
		24521
	],
	"./de/index": [
		73282,
		7,
		73282
	],
	"./de/index.d": [
		39200,
		9,
		54055
	],
	"./de/index.d.ts": [
		39200,
		9,
		54055
	],
	"./de/index.js": [
		73282,
		7,
		73282
	],
	"./de/index.js.flow": [
		43152,
		1,
		43152
	],
	"./de/package": [
		1136,
		3,
		1136
	],
	"./de/package.json": [
		1136,
		3,
		1136
	],
	"./el": [
		93277,
		9,
		93277
	],
	"./el/": [
		93277,
		9,
		93277
	],
	"./el/_lib/formatDistance": [
		5758,
		7,
		5758
	],
	"./el/_lib/formatDistance/": [
		5758,
		7,
		5758
	],
	"./el/_lib/formatDistance/index": [
		5758,
		7,
		5758
	],
	"./el/_lib/formatDistance/index.js": [
		5758,
		7,
		5758
	],
	"./el/_lib/formatLong": [
		26073,
		7,
		26073
	],
	"./el/_lib/formatLong/": [
		26073,
		7,
		26073
	],
	"./el/_lib/formatLong/index": [
		26073,
		7,
		26073
	],
	"./el/_lib/formatLong/index.js": [
		26073,
		7,
		26073
	],
	"./el/_lib/formatRelative": [
		60417,
		7,
		60417
	],
	"./el/_lib/formatRelative/": [
		60417,
		7,
		60417
	],
	"./el/_lib/formatRelative/index": [
		60417,
		7,
		60417
	],
	"./el/_lib/formatRelative/index.js": [
		60417,
		7,
		60417
	],
	"./el/_lib/localize": [
		81695,
		7,
		81695
	],
	"./el/_lib/localize/": [
		81695,
		7,
		81695
	],
	"./el/_lib/localize/index": [
		81695,
		7,
		81695
	],
	"./el/_lib/localize/index.js": [
		81695,
		7,
		81695
	],
	"./el/_lib/match": [
		30251,
		7,
		30251
	],
	"./el/_lib/match/": [
		30251,
		7,
		30251
	],
	"./el/_lib/match/index": [
		30251,
		7,
		30251
	],
	"./el/_lib/match/index.js": [
		30251,
		7,
		30251
	],
	"./el/index": [
		98258,
		7,
		98258
	],
	"./el/index.d": [
		58432,
		9,
		58432
	],
	"./el/index.d.ts": [
		58432,
		9,
		58432
	],
	"./el/index.js": [
		98258,
		7,
		98258
	],
	"./el/index.js.flow": [
		61977,
		1,
		61977
	],
	"./el/package": [
		67896,
		3,
		67896
	],
	"./el/package.json": [
		67896,
		3,
		67896
	],
	"./en-AU": [
		18945,
		9,
		18945
	],
	"./en-AU/": [
		18945,
		9,
		18945
	],
	"./en-AU/_lib/formatLong": [
		67164,
		7,
		67164
	],
	"./en-AU/_lib/formatLong/": [
		67164,
		7,
		67164
	],
	"./en-AU/_lib/formatLong/index": [
		67164,
		7,
		67164
	],
	"./en-AU/_lib/formatLong/index.js": [
		67164,
		7,
		67164
	],
	"./en-AU/index": [
		21566,
		7,
		21566
	],
	"./en-AU/index.d": [
		23794,
		9,
		23794
	],
	"./en-AU/index.d.ts": [
		23794,
		9,
		23794
	],
	"./en-AU/index.js": [
		21566,
		7,
		21566
	],
	"./en-AU/index.js.flow": [
		63826,
		1,
		63826
	],
	"./en-AU/package": [
		87445,
		3,
		87445
	],
	"./en-AU/package.json": [
		87445,
		3,
		87445
	],
	"./en-CA": [
		64319,
		9,
		64319
	],
	"./en-CA/": [
		64319,
		9,
		64319
	],
	"./en-CA/_lib/formatDistance": [
		73258,
		7,
		73258
	],
	"./en-CA/_lib/formatDistance/": [
		73258,
		7,
		73258
	],
	"./en-CA/_lib/formatDistance/index": [
		73258,
		7,
		73258
	],
	"./en-CA/_lib/formatDistance/index.js": [
		73258,
		7,
		73258
	],
	"./en-CA/_lib/formatLong": [
		55599,
		7,
		55599
	],
	"./en-CA/_lib/formatLong/": [
		55599,
		7,
		55599
	],
	"./en-CA/_lib/formatLong/index": [
		55599,
		7,
		55599
	],
	"./en-CA/_lib/formatLong/index.js": [
		55599,
		7,
		55599
	],
	"./en-CA/index": [
		40502,
		7,
		40502
	],
	"./en-CA/index.d": [
		33917,
		9,
		33917
	],
	"./en-CA/index.d.ts": [
		33917,
		9,
		33917
	],
	"./en-CA/index.js": [
		40502,
		7,
		40502
	],
	"./en-CA/index.js.flow": [
		56075,
		1,
		56075
	],
	"./en-CA/package": [
		61714,
		3,
		61714
	],
	"./en-CA/package.json": [
		61714,
		3,
		61714
	],
	"./en-GB": [
		73947,
		9
	],
	"./en-GB/": [
		73947,
		9
	],
	"./en-GB/_lib/formatLong": [
		47289,
		7,
		47289
	],
	"./en-GB/_lib/formatLong/": [
		47289,
		7,
		47289
	],
	"./en-GB/_lib/formatLong/index": [
		47289,
		7,
		47289
	],
	"./en-GB/_lib/formatLong/index.js": [
		47289,
		7,
		47289
	],
	"./en-GB/index": [
		38807,
		7,
		38807
	],
	"./en-GB/index.d": [
		83007,
		9,
		83007
	],
	"./en-GB/index.d.ts": [
		83007,
		9,
		83007
	],
	"./en-GB/index.js": [
		38807,
		7,
		38807
	],
	"./en-GB/index.js.flow": [
		47317,
		1,
		47317
	],
	"./en-GB/package": [
		79204,
		3,
		79204
	],
	"./en-GB/package.json": [
		79204,
		3,
		79204
	],
	"./en-IN": [
		77749,
		9,
		77749
	],
	"./en-IN/": [
		77749,
		9,
		77749
	],
	"./en-IN/_lib/formatLong": [
		5179,
		7,
		5179
	],
	"./en-IN/_lib/formatLong/": [
		5179,
		7,
		5179
	],
	"./en-IN/_lib/formatLong/index": [
		5179,
		7,
		5179
	],
	"./en-IN/_lib/formatLong/index.js": [
		5179,
		7,
		5179
	],
	"./en-IN/index": [
		34082,
		7,
		34082
	],
	"./en-IN/index.d": [
		27138,
		9,
		27138
	],
	"./en-IN/index.d.ts": [
		27138,
		9,
		27138
	],
	"./en-IN/index.js": [
		34082,
		7,
		34082
	],
	"./en-IN/index.js.flow": [
		2715,
		1,
		2715
	],
	"./en-IN/package": [
		52063,
		3,
		52063
	],
	"./en-IN/package.json": [
		52063,
		3,
		52063
	],
	"./en-NZ": [
		2471,
		9,
		2471
	],
	"./en-NZ/": [
		2471,
		9,
		2471
	],
	"./en-NZ/_lib/formatLong": [
		21441,
		7,
		21441
	],
	"./en-NZ/_lib/formatLong/": [
		21441,
		7,
		21441
	],
	"./en-NZ/_lib/formatLong/index": [
		21441,
		7,
		21441
	],
	"./en-NZ/_lib/formatLong/index.js": [
		21441,
		7,
		21441
	],
	"./en-NZ/index": [
		96460,
		7,
		96460
	],
	"./en-NZ/index.d": [
		8304,
		9,
		8304
	],
	"./en-NZ/index.d.ts": [
		8304,
		9,
		8304
	],
	"./en-NZ/index.js": [
		96460,
		7,
		96460
	],
	"./en-NZ/index.js.flow": [
		55509,
		1,
		55509
	],
	"./en-NZ/package": [
		84177,
		3,
		84177
	],
	"./en-NZ/package.json": [
		84177,
		3,
		84177
	],
	"./en-US": [
		85365,
		9
	],
	"./en-US/": [
		85365,
		9
	],
	"./en-US/_lib/formatDistance": [
		18878,
		7,
		18878
	],
	"./en-US/_lib/formatDistance/": [
		18878,
		7,
		18878
	],
	"./en-US/_lib/formatDistance/index": [
		18878,
		7,
		18878
	],
	"./en-US/_lib/formatDistance/index.js": [
		18878,
		7,
		18878
	],
	"./en-US/_lib/formatLong": [
		93489,
		7,
		93489
	],
	"./en-US/_lib/formatLong/": [
		93489,
		7,
		93489
	],
	"./en-US/_lib/formatLong/index": [
		93489,
		7,
		93489
	],
	"./en-US/_lib/formatLong/index.js": [
		93489,
		7,
		93489
	],
	"./en-US/_lib/formatRelative": [
		4337,
		7,
		4337
	],
	"./en-US/_lib/formatRelative/": [
		4337,
		7,
		4337
	],
	"./en-US/_lib/formatRelative/index": [
		4337,
		7,
		4337
	],
	"./en-US/_lib/formatRelative/index.js": [
		4337,
		7,
		4337
	],
	"./en-US/_lib/localize": [
		320,
		7,
		320
	],
	"./en-US/_lib/localize/": [
		320,
		7,
		320
	],
	"./en-US/_lib/localize/index": [
		320,
		7,
		320
	],
	"./en-US/_lib/localize/index.js": [
		320,
		7,
		320
	],
	"./en-US/_lib/match": [
		16317,
		7,
		16317
	],
	"./en-US/_lib/match/": [
		16317,
		7,
		16317
	],
	"./en-US/_lib/match/index": [
		16317,
		7,
		16317
	],
	"./en-US/_lib/match/index.js": [
		16317,
		7,
		16317
	],
	"./en-US/index": [
		8104,
		7,
		8104
	],
	"./en-US/index.d": [
		27576,
		9,
		27576
	],
	"./en-US/index.d.ts": [
		27576,
		9,
		27576
	],
	"./en-US/index.js": [
		8104,
		7,
		8104
	],
	"./en-US/index.js.flow": [
		41647,
		1,
		41647
	],
	"./en-US/package": [
		89049,
		3,
		89049
	],
	"./en-US/package.json": [
		89049,
		3,
		89049
	],
	"./en-ZA": [
		2361,
		9,
		2361
	],
	"./en-ZA/": [
		2361,
		9,
		2361
	],
	"./en-ZA/_lib/formatLong": [
		37590,
		7,
		37590
	],
	"./en-ZA/_lib/formatLong/": [
		37590,
		7,
		37590
	],
	"./en-ZA/_lib/formatLong/index": [
		37590,
		7,
		37590
	],
	"./en-ZA/_lib/formatLong/index.js": [
		37590,
		7,
		37590
	],
	"./en-ZA/index": [
		25917,
		7,
		25917
	],
	"./en-ZA/index.d": [
		20597,
		9,
		20597
	],
	"./en-ZA/index.d.ts": [
		20597,
		9,
		20597
	],
	"./en-ZA/index.js": [
		25917,
		7,
		25917
	],
	"./en-ZA/index.js.flow": [
		7902,
		1,
		7902
	],
	"./en-ZA/package": [
		96657,
		3,
		96657
	],
	"./en-ZA/package.json": [
		96657,
		3,
		96657
	],
	"./eo": [
		79729,
		9,
		79729
	],
	"./eo/": [
		79729,
		9,
		79729
	],
	"./eo/_lib/formatDistance": [
		60074,
		7,
		60074
	],
	"./eo/_lib/formatDistance/": [
		60074,
		7,
		60074
	],
	"./eo/_lib/formatDistance/index": [
		60074,
		7,
		60074
	],
	"./eo/_lib/formatDistance/index.js": [
		60074,
		7,
		60074
	],
	"./eo/_lib/formatLong": [
		63355,
		7,
		63355
	],
	"./eo/_lib/formatLong/": [
		63355,
		7,
		63355
	],
	"./eo/_lib/formatLong/index": [
		63355,
		7,
		63355
	],
	"./eo/_lib/formatLong/index.js": [
		63355,
		7,
		63355
	],
	"./eo/_lib/formatRelative": [
		20205,
		7,
		20205
	],
	"./eo/_lib/formatRelative/": [
		20205,
		7,
		20205
	],
	"./eo/_lib/formatRelative/index": [
		20205,
		7,
		20205
	],
	"./eo/_lib/formatRelative/index.js": [
		20205,
		7,
		20205
	],
	"./eo/_lib/localize": [
		99069,
		7,
		99069
	],
	"./eo/_lib/localize/": [
		99069,
		7,
		99069
	],
	"./eo/_lib/localize/index": [
		99069,
		7,
		99069
	],
	"./eo/_lib/localize/index.js": [
		99069,
		7,
		99069
	],
	"./eo/_lib/match": [
		90987,
		7,
		90987
	],
	"./eo/_lib/match/": [
		90987,
		7,
		90987
	],
	"./eo/_lib/match/index": [
		90987,
		7,
		90987
	],
	"./eo/_lib/match/index.js": [
		90987,
		7,
		90987
	],
	"./eo/index": [
		83332,
		7,
		83332
	],
	"./eo/index.d": [
		66479,
		9,
		66479
	],
	"./eo/index.d.ts": [
		66479,
		9,
		66479
	],
	"./eo/index.js": [
		83332,
		7,
		83332
	],
	"./eo/index.js.flow": [
		17585,
		1,
		17585
	],
	"./eo/package": [
		4346,
		3,
		4346
	],
	"./eo/package.json": [
		4346,
		3,
		4346
	],
	"./es": [
		41516,
		9,
		41516
	],
	"./es/": [
		41516,
		9,
		41516
	],
	"./es/_lib/formatDistance": [
		7301,
		7,
		7301
	],
	"./es/_lib/formatDistance/": [
		7301,
		7,
		7301
	],
	"./es/_lib/formatDistance/index": [
		7301,
		7,
		7301
	],
	"./es/_lib/formatDistance/index.js": [
		7301,
		7,
		7301
	],
	"./es/_lib/formatLong": [
		92522,
		7,
		92522
	],
	"./es/_lib/formatLong/": [
		92522,
		7,
		92522
	],
	"./es/_lib/formatLong/index": [
		92522,
		7,
		92522
	],
	"./es/_lib/formatLong/index.js": [
		92522,
		7,
		92522
	],
	"./es/_lib/formatRelative": [
		40953,
		7,
		40953
	],
	"./es/_lib/formatRelative/": [
		40953,
		7,
		40953
	],
	"./es/_lib/formatRelative/index": [
		40953,
		7,
		40953
	],
	"./es/_lib/formatRelative/index.js": [
		40953,
		7,
		40953
	],
	"./es/_lib/localize": [
		87553,
		7,
		87553
	],
	"./es/_lib/localize/": [
		87553,
		7,
		87553
	],
	"./es/_lib/localize/index": [
		87553,
		7,
		87553
	],
	"./es/_lib/localize/index.js": [
		87553,
		7,
		87553
	],
	"./es/_lib/match": [
		95895,
		7,
		95895
	],
	"./es/_lib/match/": [
		95895,
		7,
		95895
	],
	"./es/_lib/match/index": [
		95895,
		7,
		95895
	],
	"./es/_lib/match/index.js": [
		95895,
		7,
		95895
	],
	"./es/index": [
		22423,
		7,
		22423
	],
	"./es/index.d": [
		24889,
		9,
		24889
	],
	"./es/index.d.ts": [
		24889,
		9,
		24889
	],
	"./es/index.js": [
		22423,
		7,
		22423
	],
	"./es/index.js.flow": [
		84319,
		1,
		84319
	],
	"./es/package": [
		280,
		3,
		280
	],
	"./es/package.json": [
		280,
		3,
		280
	],
	"./et": [
		71375,
		9,
		71375
	],
	"./et/": [
		71375,
		9,
		71375
	],
	"./et/_lib/formatDistance": [
		75657,
		7,
		75657
	],
	"./et/_lib/formatDistance/": [
		75657,
		7,
		75657
	],
	"./et/_lib/formatDistance/index": [
		75657,
		7,
		75657
	],
	"./et/_lib/formatDistance/index.js": [
		75657,
		7,
		75657
	],
	"./et/_lib/formatLong": [
		22478,
		7,
		22478
	],
	"./et/_lib/formatLong/": [
		22478,
		7,
		22478
	],
	"./et/_lib/formatLong/index": [
		22478,
		7,
		22478
	],
	"./et/_lib/formatLong/index.js": [
		22478,
		7,
		22478
	],
	"./et/_lib/formatRelative": [
		90975,
		7,
		90975
	],
	"./et/_lib/formatRelative/": [
		90975,
		7,
		90975
	],
	"./et/_lib/formatRelative/index": [
		90975,
		7,
		90975
	],
	"./et/_lib/formatRelative/index.js": [
		90975,
		7,
		90975
	],
	"./et/_lib/localize": [
		5026,
		7,
		5026
	],
	"./et/_lib/localize/": [
		5026,
		7,
		5026
	],
	"./et/_lib/localize/index": [
		5026,
		7,
		5026
	],
	"./et/_lib/localize/index.js": [
		5026,
		7,
		5026
	],
	"./et/_lib/match": [
		11870,
		7,
		11870
	],
	"./et/_lib/match/": [
		11870,
		7,
		11870
	],
	"./et/_lib/match/index": [
		11870,
		7,
		11870
	],
	"./et/_lib/match/index.js": [
		11870,
		7,
		11870
	],
	"./et/index": [
		60138,
		7,
		60138
	],
	"./et/index.d": [
		99888,
		9,
		99888
	],
	"./et/index.d.ts": [
		99888,
		9,
		99888
	],
	"./et/index.js": [
		60138,
		7,
		60138
	],
	"./et/index.js.flow": [
		5600,
		1,
		5600
	],
	"./et/package": [
		88581,
		3,
		88581
	],
	"./et/package.json": [
		88581,
		3,
		88581
	],
	"./eu": [
		41141,
		9,
		41141
	],
	"./eu/": [
		41141,
		9,
		41141
	],
	"./eu/_lib/formatDistance": [
		2931,
		7,
		2931
	],
	"./eu/_lib/formatDistance/": [
		2931,
		7,
		2931
	],
	"./eu/_lib/formatDistance/index": [
		2931,
		7,
		2931
	],
	"./eu/_lib/formatDistance/index.js": [
		2931,
		7,
		2931
	],
	"./eu/_lib/formatLong": [
		73088,
		7,
		9736
	],
	"./eu/_lib/formatLong/": [
		73088,
		7,
		9736
	],
	"./eu/_lib/formatLong/index": [
		73088,
		7,
		9736
	],
	"./eu/_lib/formatLong/index.js": [
		73088,
		7,
		9736
	],
	"./eu/_lib/formatRelative": [
		322,
		7,
		322
	],
	"./eu/_lib/formatRelative/": [
		322,
		7,
		322
	],
	"./eu/_lib/formatRelative/index": [
		322,
		7,
		322
	],
	"./eu/_lib/formatRelative/index.js": [
		322,
		7,
		322
	],
	"./eu/_lib/localize": [
		56799,
		7,
		56799
	],
	"./eu/_lib/localize/": [
		56799,
		7,
		56799
	],
	"./eu/_lib/localize/index": [
		56799,
		7,
		56799
	],
	"./eu/_lib/localize/index.js": [
		56799,
		7,
		56799
	],
	"./eu/_lib/match": [
		22858,
		7,
		22858
	],
	"./eu/_lib/match/": [
		22858,
		7,
		22858
	],
	"./eu/_lib/match/index": [
		22858,
		7,
		22858
	],
	"./eu/_lib/match/index.js": [
		22858,
		7,
		22858
	],
	"./eu/index": [
		22694,
		7,
		22694
	],
	"./eu/index.d": [
		32860,
		9,
		32860
	],
	"./eu/index.d.ts": [
		32860,
		9,
		32860
	],
	"./eu/index.js": [
		22694,
		7,
		22694
	],
	"./eu/index.js.flow": [
		4407,
		1,
		4407
	],
	"./eu/package": [
		72634,
		3,
		72634
	],
	"./eu/package.json": [
		72634,
		3,
		72634
	],
	"./fa-IR": [
		50646,
		9,
		50646
	],
	"./fa-IR/": [
		50646,
		9,
		50646
	],
	"./fa-IR/_lib/formatDistance": [
		99362,
		7,
		99362
	],
	"./fa-IR/_lib/formatDistance/": [
		99362,
		7,
		99362
	],
	"./fa-IR/_lib/formatDistance/index": [
		99362,
		7,
		99362
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		99362,
		7,
		99362
	],
	"./fa-IR/_lib/formatLong": [
		22843,
		7,
		22843
	],
	"./fa-IR/_lib/formatLong/": [
		22843,
		7,
		22843
	],
	"./fa-IR/_lib/formatLong/index": [
		22843,
		7,
		22843
	],
	"./fa-IR/_lib/formatLong/index.js": [
		22843,
		7,
		22843
	],
	"./fa-IR/_lib/formatRelative": [
		57511,
		7,
		57511
	],
	"./fa-IR/_lib/formatRelative/": [
		57511,
		7,
		57511
	],
	"./fa-IR/_lib/formatRelative/index": [
		57511,
		7,
		57511
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		57511,
		7,
		57511
	],
	"./fa-IR/_lib/localize": [
		979,
		7,
		979
	],
	"./fa-IR/_lib/localize/": [
		979,
		7,
		979
	],
	"./fa-IR/_lib/localize/index": [
		979,
		7,
		979
	],
	"./fa-IR/_lib/localize/index.js": [
		979,
		7,
		979
	],
	"./fa-IR/_lib/match": [
		54673,
		7,
		54673
	],
	"./fa-IR/_lib/match/": [
		54673,
		7,
		54673
	],
	"./fa-IR/_lib/match/index": [
		54673,
		7,
		54673
	],
	"./fa-IR/_lib/match/index.js": [
		54673,
		7,
		54673
	],
	"./fa-IR/index": [
		40447,
		7,
		40447
	],
	"./fa-IR/index.d": [
		98943,
		9,
		98943
	],
	"./fa-IR/index.d.ts": [
		98943,
		9,
		98943
	],
	"./fa-IR/index.js": [
		40447,
		7,
		40447
	],
	"./fa-IR/index.js.flow": [
		87971,
		1,
		87971
	],
	"./fa-IR/package": [
		83136,
		3,
		83136
	],
	"./fa-IR/package.json": [
		83136,
		3,
		83136
	],
	"./fi": [
		17948,
		9,
		17948
	],
	"./fi/": [
		17948,
		9,
		17948
	],
	"./fi/_lib/formatDistance": [
		18747,
		7,
		18747
	],
	"./fi/_lib/formatDistance/": [
		18747,
		7,
		18747
	],
	"./fi/_lib/formatDistance/index": [
		18747,
		7,
		18747
	],
	"./fi/_lib/formatDistance/index.js": [
		18747,
		7,
		18747
	],
	"./fi/_lib/formatLong": [
		72056,
		7,
		72056
	],
	"./fi/_lib/formatLong/": [
		72056,
		7,
		72056
	],
	"./fi/_lib/formatLong/index": [
		72056,
		7,
		72056
	],
	"./fi/_lib/formatLong/index.js": [
		72056,
		7,
		72056
	],
	"./fi/_lib/formatRelative": [
		55801,
		7,
		55801
	],
	"./fi/_lib/formatRelative/": [
		55801,
		7,
		55801
	],
	"./fi/_lib/formatRelative/index": [
		55801,
		7,
		55801
	],
	"./fi/_lib/formatRelative/index.js": [
		55801,
		7,
		55801
	],
	"./fi/_lib/localize": [
		5124,
		7,
		5124
	],
	"./fi/_lib/localize/": [
		5124,
		7,
		5124
	],
	"./fi/_lib/localize/index": [
		5124,
		7,
		5124
	],
	"./fi/_lib/localize/index.js": [
		5124,
		7,
		5124
	],
	"./fi/_lib/match": [
		19881,
		7,
		19881
	],
	"./fi/_lib/match/": [
		19881,
		7,
		19881
	],
	"./fi/_lib/match/index": [
		19881,
		7,
		19881
	],
	"./fi/_lib/match/index.js": [
		19881,
		7,
		19881
	],
	"./fi/index": [
		98572,
		7,
		98572
	],
	"./fi/index.d": [
		96273,
		9,
		96273
	],
	"./fi/index.d.ts": [
		96273,
		9,
		96273
	],
	"./fi/index.js": [
		98572,
		7,
		98572
	],
	"./fi/index.js.flow": [
		35313,
		1,
		35313
	],
	"./fi/package": [
		10482,
		3,
		10482
	],
	"./fi/package.json": [
		10482,
		3,
		10482
	],
	"./fr": [
		43860,
		9,
		43860
	],
	"./fr-CA": [
		77490,
		9,
		77490
	],
	"./fr-CA/": [
		77490,
		9,
		77490
	],
	"./fr-CA/_lib/formatLong": [
		59563,
		7,
		59563
	],
	"./fr-CA/_lib/formatLong/": [
		59563,
		7,
		59563
	],
	"./fr-CA/_lib/formatLong/index": [
		59563,
		7,
		59563
	],
	"./fr-CA/_lib/formatLong/index.js": [
		59563,
		7,
		59563
	],
	"./fr-CA/index": [
		93413,
		7,
		93413
	],
	"./fr-CA/index.d": [
		5217,
		9,
		5217
	],
	"./fr-CA/index.d.ts": [
		5217,
		9,
		5217
	],
	"./fr-CA/index.js": [
		93413,
		7,
		93413
	],
	"./fr-CA/index.js.flow": [
		14097,
		1,
		14097
	],
	"./fr-CA/package": [
		29653,
		3,
		29653
	],
	"./fr-CA/package.json": [
		29653,
		3,
		29653
	],
	"./fr-CH": [
		97720,
		9,
		97720
	],
	"./fr-CH/": [
		97720,
		9,
		97720
	],
	"./fr-CH/_lib/formatDistance": [
		91903,
		7,
		91903
	],
	"./fr-CH/_lib/formatDistance/": [
		91903,
		7,
		91903
	],
	"./fr-CH/_lib/formatDistance/index": [
		91903,
		7,
		91903
	],
	"./fr-CH/_lib/formatDistance/index.js": [
		91903,
		7,
		91903
	],
	"./fr-CH/_lib/formatLong": [
		36218,
		7,
		36218
	],
	"./fr-CH/_lib/formatLong/": [
		36218,
		7,
		36218
	],
	"./fr-CH/_lib/formatLong/index": [
		36218,
		7,
		36218
	],
	"./fr-CH/_lib/formatLong/index.js": [
		36218,
		7,
		36218
	],
	"./fr-CH/_lib/formatRelative": [
		7158,
		7,
		7158
	],
	"./fr-CH/_lib/formatRelative/": [
		7158,
		7,
		7158
	],
	"./fr-CH/_lib/formatRelative/index": [
		7158,
		7,
		7158
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		7158,
		7,
		7158
	],
	"./fr-CH/_lib/formatters": [
		87322,
		7,
		87322
	],
	"./fr-CH/_lib/formatters/": [
		87322,
		7,
		87322
	],
	"./fr-CH/_lib/formatters/index": [
		87322,
		7,
		87322
	],
	"./fr-CH/_lib/formatters/index.js": [
		87322,
		7,
		87322
	],
	"./fr-CH/_lib/localize": [
		58560,
		7,
		58560
	],
	"./fr-CH/_lib/localize/": [
		58560,
		7,
		58560
	],
	"./fr-CH/_lib/localize/index": [
		58560,
		7,
		58560
	],
	"./fr-CH/_lib/localize/index.js": [
		58560,
		7,
		58560
	],
	"./fr-CH/_lib/match": [
		81934,
		7,
		81934
	],
	"./fr-CH/_lib/match/": [
		81934,
		7,
		81934
	],
	"./fr-CH/_lib/match/index": [
		81934,
		7,
		81934
	],
	"./fr-CH/_lib/match/index.js": [
		81934,
		7,
		81934
	],
	"./fr-CH/index": [
		84960,
		7,
		84960
	],
	"./fr-CH/index.d": [
		70174,
		9,
		70174
	],
	"./fr-CH/index.d.ts": [
		70174,
		9,
		70174
	],
	"./fr-CH/index.js": [
		84960,
		7,
		84960
	],
	"./fr-CH/index.js.flow": [
		20241,
		1,
		20241
	],
	"./fr-CH/package": [
		43141,
		3,
		43141
	],
	"./fr-CH/package.json": [
		43141,
		3,
		43141
	],
	"./fr/": [
		43860,
		9,
		43860
	],
	"./fr/_lib/formatDistance": [
		35332,
		7,
		35332
	],
	"./fr/_lib/formatDistance/": [
		35332,
		7,
		35332
	],
	"./fr/_lib/formatDistance/index": [
		35332,
		7,
		35332
	],
	"./fr/_lib/formatDistance/index.js": [
		35332,
		7,
		35332
	],
	"./fr/_lib/formatLong": [
		21709,
		7,
		21709
	],
	"./fr/_lib/formatLong/": [
		21709,
		7,
		21709
	],
	"./fr/_lib/formatLong/index": [
		21709,
		7,
		21709
	],
	"./fr/_lib/formatLong/index.js": [
		21709,
		7,
		21709
	],
	"./fr/_lib/formatRelative": [
		99572,
		7,
		99572
	],
	"./fr/_lib/formatRelative/": [
		99572,
		7,
		99572
	],
	"./fr/_lib/formatRelative/index": [
		99572,
		7,
		99572
	],
	"./fr/_lib/formatRelative/index.js": [
		99572,
		7,
		99572
	],
	"./fr/_lib/formatters": [
		77881,
		7,
		77881
	],
	"./fr/_lib/formatters/": [
		77881,
		7,
		77881
	],
	"./fr/_lib/formatters/index": [
		77881,
		7,
		77881
	],
	"./fr/_lib/formatters/index.js": [
		77881,
		7,
		77881
	],
	"./fr/_lib/localize": [
		78049,
		7,
		78049
	],
	"./fr/_lib/localize/": [
		78049,
		7,
		78049
	],
	"./fr/_lib/localize/index": [
		78049,
		7,
		78049
	],
	"./fr/_lib/localize/index.js": [
		78049,
		7,
		78049
	],
	"./fr/_lib/match": [
		45632,
		7,
		45632
	],
	"./fr/_lib/match/": [
		45632,
		7,
		45632
	],
	"./fr/_lib/match/index": [
		45632,
		7,
		45632
	],
	"./fr/_lib/match/index.js": [
		45632,
		7,
		45632
	],
	"./fr/index": [
		90335,
		7,
		90335
	],
	"./fr/index.d": [
		2149,
		9,
		2149
	],
	"./fr/index.d.ts": [
		2149,
		9,
		2149
	],
	"./fr/index.js": [
		90335,
		7,
		90335
	],
	"./fr/index.js.flow": [
		98437,
		1,
		98437
	],
	"./fr/package": [
		80704,
		3,
		80704
	],
	"./fr/package.json": [
		80704,
		3,
		80704
	],
	"./gd": [
		66426,
		9,
		66426
	],
	"./gd/": [
		66426,
		9,
		66426
	],
	"./gd/_lib/formatDistance": [
		62247,
		7,
		62247
	],
	"./gd/_lib/formatDistance/": [
		62247,
		7,
		62247
	],
	"./gd/_lib/formatDistance/index": [
		62247,
		7,
		62247
	],
	"./gd/_lib/formatDistance/index.js": [
		62247,
		7,
		62247
	],
	"./gd/_lib/formatLong": [
		67770,
		7,
		67770
	],
	"./gd/_lib/formatLong/": [
		67770,
		7,
		67770
	],
	"./gd/_lib/formatLong/index": [
		67770,
		7,
		67770
	],
	"./gd/_lib/formatLong/index.js": [
		67770,
		7,
		67770
	],
	"./gd/_lib/formatRelative": [
		66471,
		7,
		66471
	],
	"./gd/_lib/formatRelative/": [
		66471,
		7,
		66471
	],
	"./gd/_lib/formatRelative/index": [
		66471,
		7,
		66471
	],
	"./gd/_lib/formatRelative/index.js": [
		66471,
		7,
		66471
	],
	"./gd/_lib/localize": [
		1893,
		7,
		1893
	],
	"./gd/_lib/localize/": [
		1893,
		7,
		1893
	],
	"./gd/_lib/localize/index": [
		1893,
		7,
		1893
	],
	"./gd/_lib/localize/index.js": [
		1893,
		7,
		1893
	],
	"./gd/_lib/match": [
		69547,
		7,
		69547
	],
	"./gd/_lib/match/": [
		69547,
		7,
		69547
	],
	"./gd/_lib/match/index": [
		69547,
		7,
		69547
	],
	"./gd/_lib/match/index.js": [
		69547,
		7,
		69547
	],
	"./gd/index": [
		66254,
		7,
		66254
	],
	"./gd/index.d": [
		15365,
		9,
		15365
	],
	"./gd/index.d.ts": [
		15365,
		9,
		15365
	],
	"./gd/index.js": [
		66254,
		7,
		66254
	],
	"./gd/index.js.flow": [
		10637,
		1,
		10637
	],
	"./gd/package": [
		50530,
		3,
		50530
	],
	"./gd/package.json": [
		50530,
		3,
		50530
	],
	"./gl": [
		9876,
		9,
		9876
	],
	"./gl/": [
		9876,
		9,
		9876
	],
	"./gl/_lib/formatDistance": [
		35721,
		7,
		35721
	],
	"./gl/_lib/formatDistance/": [
		35721,
		7,
		35721
	],
	"./gl/_lib/formatDistance/index": [
		35721,
		7,
		35721
	],
	"./gl/_lib/formatDistance/index.js": [
		35721,
		7,
		35721
	],
	"./gl/_lib/formatLong": [
		19256,
		7,
		19256
	],
	"./gl/_lib/formatLong/": [
		19256,
		7,
		19256
	],
	"./gl/_lib/formatLong/index": [
		19256,
		7,
		19256
	],
	"./gl/_lib/formatLong/index.js": [
		19256,
		7,
		19256
	],
	"./gl/_lib/formatRelative": [
		99643,
		7,
		99643
	],
	"./gl/_lib/formatRelative/": [
		99643,
		7,
		99643
	],
	"./gl/_lib/formatRelative/index": [
		99643,
		7,
		99643
	],
	"./gl/_lib/formatRelative/index.js": [
		99643,
		7,
		99643
	],
	"./gl/_lib/localize": [
		64185,
		7,
		64185
	],
	"./gl/_lib/localize/": [
		64185,
		7,
		64185
	],
	"./gl/_lib/localize/index": [
		64185,
		7,
		64185
	],
	"./gl/_lib/localize/index.js": [
		64185,
		7,
		64185
	],
	"./gl/_lib/match": [
		54958,
		7,
		54958
	],
	"./gl/_lib/match/": [
		54958,
		7,
		54958
	],
	"./gl/_lib/match/index": [
		54958,
		7,
		54958
	],
	"./gl/_lib/match/index.js": [
		54958,
		7,
		54958
	],
	"./gl/index": [
		79962,
		7,
		79962
	],
	"./gl/index.d": [
		18013,
		9,
		18013
	],
	"./gl/index.d.ts": [
		18013,
		9,
		18013
	],
	"./gl/index.js": [
		79962,
		7,
		79962
	],
	"./gl/index.js.flow": [
		13021,
		1,
		13021
	],
	"./gl/package": [
		28553,
		3,
		28553
	],
	"./gl/package.json": [
		28553,
		3,
		28553
	],
	"./gu": [
		82666,
		9,
		82666
	],
	"./gu/": [
		82666,
		9,
		82666
	],
	"./gu/_lib/formatDistance": [
		39713,
		7,
		39713
	],
	"./gu/_lib/formatDistance/": [
		39713,
		7,
		39713
	],
	"./gu/_lib/formatDistance/index": [
		39713,
		7,
		39713
	],
	"./gu/_lib/formatDistance/index.js": [
		39713,
		7,
		39713
	],
	"./gu/_lib/formatLong": [
		52278,
		7,
		52278
	],
	"./gu/_lib/formatLong/": [
		52278,
		7,
		52278
	],
	"./gu/_lib/formatLong/index": [
		52278,
		7,
		52278
	],
	"./gu/_lib/formatLong/index.js": [
		52278,
		7,
		52278
	],
	"./gu/_lib/formatRelative": [
		3820,
		7,
		3820
	],
	"./gu/_lib/formatRelative/": [
		3820,
		7,
		3820
	],
	"./gu/_lib/formatRelative/index": [
		3820,
		7,
		3820
	],
	"./gu/_lib/formatRelative/index.js": [
		3820,
		7,
		3820
	],
	"./gu/_lib/localize": [
		52110,
		7,
		52110
	],
	"./gu/_lib/localize/": [
		52110,
		7,
		52110
	],
	"./gu/_lib/localize/index": [
		52110,
		7,
		52110
	],
	"./gu/_lib/localize/index.js": [
		52110,
		7,
		52110
	],
	"./gu/_lib/match": [
		84969,
		7,
		84969
	],
	"./gu/_lib/match/": [
		84969,
		7,
		84969
	],
	"./gu/_lib/match/index": [
		84969,
		7,
		84969
	],
	"./gu/_lib/match/index.js": [
		84969,
		7,
		84969
	],
	"./gu/index": [
		69729,
		7,
		69729
	],
	"./gu/index.d": [
		30415,
		9,
		30415
	],
	"./gu/index.d.ts": [
		30415,
		9,
		30415
	],
	"./gu/index.js": [
		69729,
		7,
		69729
	],
	"./gu/index.js.flow": [
		42238,
		1,
		42238
	],
	"./gu/package": [
		20152,
		3,
		20152
	],
	"./gu/package.json": [
		20152,
		3,
		20152
	],
	"./he": [
		41363,
		9,
		41363
	],
	"./he/": [
		41363,
		9,
		41363
	],
	"./he/_lib/formatDistance": [
		60438,
		7,
		60438
	],
	"./he/_lib/formatDistance/": [
		60438,
		7,
		60438
	],
	"./he/_lib/formatDistance/index": [
		60438,
		7,
		60438
	],
	"./he/_lib/formatDistance/index.js": [
		60438,
		7,
		60438
	],
	"./he/_lib/formatLong": [
		22333,
		7,
		22333
	],
	"./he/_lib/formatLong/": [
		22333,
		7,
		22333
	],
	"./he/_lib/formatLong/index": [
		22333,
		7,
		22333
	],
	"./he/_lib/formatLong/index.js": [
		22333,
		7,
		22333
	],
	"./he/_lib/formatRelative": [
		93736,
		7,
		93736
	],
	"./he/_lib/formatRelative/": [
		93736,
		7,
		93736
	],
	"./he/_lib/formatRelative/index": [
		93736,
		7,
		93736
	],
	"./he/_lib/formatRelative/index.js": [
		93736,
		7,
		93736
	],
	"./he/_lib/localize": [
		76105,
		7,
		76105
	],
	"./he/_lib/localize/": [
		76105,
		7,
		76105
	],
	"./he/_lib/localize/index": [
		76105,
		7,
		76105
	],
	"./he/_lib/localize/index.js": [
		76105,
		7,
		76105
	],
	"./he/_lib/match": [
		97846,
		7,
		97846
	],
	"./he/_lib/match/": [
		97846,
		7,
		97846
	],
	"./he/_lib/match/index": [
		97846,
		7,
		97846
	],
	"./he/_lib/match/index.js": [
		97846,
		7,
		97846
	],
	"./he/index": [
		12345,
		7,
		12345
	],
	"./he/index.d": [
		19511,
		9,
		19511
	],
	"./he/index.d.ts": [
		19511,
		9,
		19511
	],
	"./he/index.js": [
		12345,
		7,
		12345
	],
	"./he/index.js.flow": [
		30171,
		1,
		30171
	],
	"./he/package": [
		68373,
		3,
		68373
	],
	"./he/package.json": [
		68373,
		3,
		68373
	],
	"./hi": [
		77271,
		9,
		77271
	],
	"./hi/": [
		77271,
		9,
		77271
	],
	"./hi/_lib/formatDistance": [
		24165,
		7,
		24165
	],
	"./hi/_lib/formatDistance/": [
		24165,
		7,
		24165
	],
	"./hi/_lib/formatDistance/index": [
		24165,
		7,
		24165
	],
	"./hi/_lib/formatDistance/index.js": [
		24165,
		7,
		24165
	],
	"./hi/_lib/formatLong": [
		54725,
		7,
		54725
	],
	"./hi/_lib/formatLong/": [
		54725,
		7,
		54725
	],
	"./hi/_lib/formatLong/index": [
		54725,
		7,
		54725
	],
	"./hi/_lib/formatLong/index.js": [
		54725,
		7,
		54725
	],
	"./hi/_lib/formatRelative": [
		16171,
		7,
		16171
	],
	"./hi/_lib/formatRelative/": [
		16171,
		7,
		16171
	],
	"./hi/_lib/formatRelative/index": [
		16171,
		7,
		16171
	],
	"./hi/_lib/formatRelative/index.js": [
		16171,
		7,
		16171
	],
	"./hi/_lib/localize": [
		91375,
		7,
		91375
	],
	"./hi/_lib/localize/": [
		91375,
		7,
		91375
	],
	"./hi/_lib/localize/index": [
		91375,
		7,
		91375
	],
	"./hi/_lib/localize/index.js": [
		91375,
		7,
		91375
	],
	"./hi/_lib/match": [
		7621,
		7,
		7621
	],
	"./hi/_lib/match/": [
		7621,
		7,
		7621
	],
	"./hi/_lib/match/index": [
		7621,
		7,
		7621
	],
	"./hi/_lib/match/index.js": [
		7621,
		7,
		7621
	],
	"./hi/index": [
		97840,
		7,
		97840
	],
	"./hi/index.d": [
		37112,
		9,
		37112
	],
	"./hi/index.d.ts": [
		37112,
		9,
		37112
	],
	"./hi/index.js": [
		97840,
		7,
		97840
	],
	"./hi/index.js.flow": [
		80998,
		1,
		80998
	],
	"./hi/package": [
		81117,
		3,
		81117
	],
	"./hi/package.json": [
		81117,
		3,
		81117
	],
	"./hr": [
		58946,
		9,
		58946
	],
	"./hr/": [
		58946,
		9,
		58946
	],
	"./hr/_lib/formatDistance": [
		3170,
		7,
		3170
	],
	"./hr/_lib/formatDistance/": [
		3170,
		7,
		3170
	],
	"./hr/_lib/formatDistance/index": [
		3170,
		7,
		3170
	],
	"./hr/_lib/formatDistance/index.js": [
		3170,
		7,
		3170
	],
	"./hr/_lib/formatLong": [
		15091,
		7,
		15091
	],
	"./hr/_lib/formatLong/": [
		15091,
		7,
		15091
	],
	"./hr/_lib/formatLong/index": [
		15091,
		7,
		15091
	],
	"./hr/_lib/formatLong/index.js": [
		15091,
		7,
		15091
	],
	"./hr/_lib/formatRelative": [
		41662,
		7,
		41662
	],
	"./hr/_lib/formatRelative/": [
		41662,
		7,
		41662
	],
	"./hr/_lib/formatRelative/index": [
		41662,
		7,
		41662
	],
	"./hr/_lib/formatRelative/index.js": [
		41662,
		7,
		41662
	],
	"./hr/_lib/localize": [
		87385,
		7,
		87385
	],
	"./hr/_lib/localize/": [
		87385,
		7,
		87385
	],
	"./hr/_lib/localize/index": [
		87385,
		7,
		87385
	],
	"./hr/_lib/localize/index.js": [
		87385,
		7,
		87385
	],
	"./hr/_lib/match": [
		56433,
		7,
		56433
	],
	"./hr/_lib/match/": [
		56433,
		7,
		56433
	],
	"./hr/_lib/match/index": [
		56433,
		7,
		56433
	],
	"./hr/_lib/match/index.js": [
		56433,
		7,
		56433
	],
	"./hr/index": [
		72081,
		7,
		72081
	],
	"./hr/index.d": [
		10841,
		9,
		10841
	],
	"./hr/index.d.ts": [
		10841,
		9,
		10841
	],
	"./hr/index.js": [
		72081,
		7,
		72081
	],
	"./hr/index.js.flow": [
		90030,
		1,
		90030
	],
	"./hr/package": [
		1813,
		3,
		1813
	],
	"./hr/package.json": [
		1813,
		3,
		1813
	],
	"./ht": [
		11116,
		9,
		11116
	],
	"./ht/": [
		11116,
		9,
		11116
	],
	"./ht/_lib/formatDistance": [
		44644,
		7,
		44644
	],
	"./ht/_lib/formatDistance/": [
		44644,
		7,
		44644
	],
	"./ht/_lib/formatDistance/index": [
		44644,
		7,
		44644
	],
	"./ht/_lib/formatDistance/index.js": [
		44644,
		7,
		44644
	],
	"./ht/_lib/formatLong": [
		58111,
		7,
		58111
	],
	"./ht/_lib/formatLong/": [
		58111,
		7,
		58111
	],
	"./ht/_lib/formatLong/index": [
		58111,
		7,
		58111
	],
	"./ht/_lib/formatLong/index.js": [
		58111,
		7,
		58111
	],
	"./ht/_lib/formatRelative": [
		51953,
		7,
		51953
	],
	"./ht/_lib/formatRelative/": [
		51953,
		7,
		51953
	],
	"./ht/_lib/formatRelative/index": [
		51953,
		7,
		51953
	],
	"./ht/_lib/formatRelative/index.js": [
		51953,
		7,
		51953
	],
	"./ht/_lib/formatters": [
		79264,
		7,
		79264
	],
	"./ht/_lib/formatters/": [
		79264,
		7,
		79264
	],
	"./ht/_lib/formatters/index": [
		79264,
		7,
		79264
	],
	"./ht/_lib/formatters/index.js": [
		79264,
		7,
		79264
	],
	"./ht/_lib/localize": [
		23735,
		7,
		23735
	],
	"./ht/_lib/localize/": [
		23735,
		7,
		23735
	],
	"./ht/_lib/localize/index": [
		23735,
		7,
		23735
	],
	"./ht/_lib/localize/index.js": [
		23735,
		7,
		23735
	],
	"./ht/_lib/match": [
		1680,
		7,
		1680
	],
	"./ht/_lib/match/": [
		1680,
		7,
		1680
	],
	"./ht/_lib/match/index": [
		1680,
		7,
		1680
	],
	"./ht/_lib/match/index.js": [
		1680,
		7,
		1680
	],
	"./ht/index": [
		70823,
		7,
		70823
	],
	"./ht/index.d": [
		69703,
		9,
		69703
	],
	"./ht/index.d.ts": [
		69703,
		9,
		69703
	],
	"./ht/index.js": [
		70823,
		7,
		70823
	],
	"./ht/index.js.flow": [
		54199,
		1,
		54199
	],
	"./ht/package": [
		17188,
		3,
		17188
	],
	"./ht/package.json": [
		17188,
		3,
		17188
	],
	"./hu": [
		12286,
		9,
		12286
	],
	"./hu/": [
		12286,
		9,
		12286
	],
	"./hu/_lib/formatDistance": [
		31517,
		7,
		31517
	],
	"./hu/_lib/formatDistance/": [
		31517,
		7,
		31517
	],
	"./hu/_lib/formatDistance/index": [
		31517,
		7,
		31517
	],
	"./hu/_lib/formatDistance/index.js": [
		31517,
		7,
		31517
	],
	"./hu/_lib/formatLong": [
		90989,
		7,
		90989
	],
	"./hu/_lib/formatLong/": [
		90989,
		7,
		90989
	],
	"./hu/_lib/formatLong/index": [
		90989,
		7,
		90989
	],
	"./hu/_lib/formatLong/index.js": [
		90989,
		7,
		90989
	],
	"./hu/_lib/formatRelative": [
		14667,
		7,
		14667
	],
	"./hu/_lib/formatRelative/": [
		14667,
		7,
		14667
	],
	"./hu/_lib/formatRelative/index": [
		14667,
		7,
		14667
	],
	"./hu/_lib/formatRelative/index.js": [
		14667,
		7,
		14667
	],
	"./hu/_lib/localize": [
		21095,
		7,
		21095
	],
	"./hu/_lib/localize/": [
		21095,
		7,
		21095
	],
	"./hu/_lib/localize/index": [
		21095,
		7,
		21095
	],
	"./hu/_lib/localize/index.js": [
		21095,
		7,
		21095
	],
	"./hu/_lib/match": [
		47204,
		7,
		47204
	],
	"./hu/_lib/match/": [
		47204,
		7,
		47204
	],
	"./hu/_lib/match/index": [
		47204,
		7,
		47204
	],
	"./hu/_lib/match/index.js": [
		47204,
		7,
		47204
	],
	"./hu/index": [
		17042,
		7,
		17042
	],
	"./hu/index.d": [
		55234,
		9,
		55234
	],
	"./hu/index.d.ts": [
		55234,
		9,
		55234
	],
	"./hu/index.js": [
		17042,
		7,
		17042
	],
	"./hu/index.js.flow": [
		92172,
		1,
		92172
	],
	"./hu/package": [
		3630,
		3,
		3630
	],
	"./hu/package.json": [
		3630,
		3,
		3630
	],
	"./hy": [
		26912,
		9,
		26912
	],
	"./hy/": [
		26912,
		9,
		26912
	],
	"./hy/_lib/formatDistance": [
		2368,
		7,
		73088
	],
	"./hy/_lib/formatDistance/": [
		2368,
		7,
		73088
	],
	"./hy/_lib/formatDistance/index": [
		2368,
		7,
		73088
	],
	"./hy/_lib/formatDistance/index.js": [
		2368,
		7,
		73088
	],
	"./hy/_lib/formatLong": [
		79647,
		7,
		79647
	],
	"./hy/_lib/formatLong/": [
		79647,
		7,
		79647
	],
	"./hy/_lib/formatLong/index": [
		79647,
		7,
		79647
	],
	"./hy/_lib/formatLong/index.js": [
		79647,
		7,
		79647
	],
	"./hy/_lib/formatRelative": [
		16236,
		7,
		16236
	],
	"./hy/_lib/formatRelative/": [
		16236,
		7,
		16236
	],
	"./hy/_lib/formatRelative/index": [
		16236,
		7,
		16236
	],
	"./hy/_lib/formatRelative/index.js": [
		16236,
		7,
		16236
	],
	"./hy/_lib/localize": [
		7290,
		7,
		7290
	],
	"./hy/_lib/localize/": [
		7290,
		7,
		7290
	],
	"./hy/_lib/localize/index": [
		7290,
		7,
		7290
	],
	"./hy/_lib/localize/index.js": [
		7290,
		7,
		7290
	],
	"./hy/_lib/match": [
		6113,
		7,
		6113
	],
	"./hy/_lib/match/": [
		6113,
		7,
		6113
	],
	"./hy/_lib/match/index": [
		6113,
		7,
		6113
	],
	"./hy/_lib/match/index.js": [
		6113,
		7,
		6113
	],
	"./hy/index": [
		29060,
		7,
		29060
	],
	"./hy/index.d": [
		37919,
		9,
		37919
	],
	"./hy/index.d.ts": [
		37919,
		9,
		37919
	],
	"./hy/index.js": [
		29060,
		7,
		29060
	],
	"./hy/index.js.flow": [
		56826,
		1,
		56826
	],
	"./hy/package": [
		47638,
		3,
		47638
	],
	"./hy/package.json": [
		47638,
		3,
		47638
	],
	"./id": [
		71017,
		9,
		71017
	],
	"./id/": [
		71017,
		9,
		71017
	],
	"./id/_lib/formatDistance": [
		86882,
		7,
		86882
	],
	"./id/_lib/formatDistance/": [
		86882,
		7,
		86882
	],
	"./id/_lib/formatDistance/index": [
		86882,
		7,
		86882
	],
	"./id/_lib/formatDistance/index.js": [
		86882,
		7,
		86882
	],
	"./id/_lib/formatLong": [
		85650,
		7,
		85650
	],
	"./id/_lib/formatLong/": [
		85650,
		7,
		85650
	],
	"./id/_lib/formatLong/index": [
		85650,
		7,
		85650
	],
	"./id/_lib/formatLong/index.js": [
		85650,
		7,
		85650
	],
	"./id/_lib/formatRelative": [
		8832,
		7,
		8832
	],
	"./id/_lib/formatRelative/": [
		8832,
		7,
		8832
	],
	"./id/_lib/formatRelative/index": [
		8832,
		7,
		8832
	],
	"./id/_lib/formatRelative/index.js": [
		8832,
		7,
		8832
	],
	"./id/_lib/localize": [
		6688,
		7,
		6688
	],
	"./id/_lib/localize/": [
		6688,
		7,
		6688
	],
	"./id/_lib/localize/index": [
		6688,
		7,
		6688
	],
	"./id/_lib/localize/index.js": [
		6688,
		7,
		6688
	],
	"./id/_lib/match": [
		77761,
		7,
		77761
	],
	"./id/_lib/match/": [
		77761,
		7,
		77761
	],
	"./id/_lib/match/index": [
		77761,
		7,
		77761
	],
	"./id/_lib/match/index.js": [
		77761,
		7,
		77761
	],
	"./id/index": [
		32655,
		7,
		32655
	],
	"./id/index.d": [
		22207,
		9,
		22207
	],
	"./id/index.d.ts": [
		22207,
		9,
		22207
	],
	"./id/index.js": [
		32655,
		7,
		32655
	],
	"./id/index.js.flow": [
		1419,
		1,
		1419
	],
	"./id/package": [
		81037,
		3,
		81037
	],
	"./id/package.json": [
		81037,
		3,
		81037
	],
	"./index": [
		45875,
		9,
		73519,
		45688,
		7243,
		2511,
		38249,
		45875
	],
	"./index.js": [
		45875,
		9,
		73519,
		45688,
		7243,
		2511,
		38249,
		45875
	],
	"./index.js.flow": [
		20636,
		1,
		20636
	],
	"./is": [
		19025,
		9,
		19025
	],
	"./is/": [
		19025,
		9,
		19025
	],
	"./is/_lib/formatDistance": [
		3264,
		7,
		3264
	],
	"./is/_lib/formatDistance/": [
		3264,
		7,
		3264
	],
	"./is/_lib/formatDistance/index": [
		3264,
		7,
		3264
	],
	"./is/_lib/formatDistance/index.js": [
		3264,
		7,
		3264
	],
	"./is/_lib/formatLong": [
		87391,
		7,
		87391
	],
	"./is/_lib/formatLong/": [
		87391,
		7,
		87391
	],
	"./is/_lib/formatLong/index": [
		87391,
		7,
		87391
	],
	"./is/_lib/formatLong/index.js": [
		87391,
		7,
		87391
	],
	"./is/_lib/formatRelative": [
		11087,
		7,
		11087
	],
	"./is/_lib/formatRelative/": [
		11087,
		7,
		11087
	],
	"./is/_lib/formatRelative/index": [
		11087,
		7,
		11087
	],
	"./is/_lib/formatRelative/index.js": [
		11087,
		7,
		11087
	],
	"./is/_lib/localize": [
		40369,
		7,
		40369
	],
	"./is/_lib/localize/": [
		40369,
		7,
		40369
	],
	"./is/_lib/localize/index": [
		40369,
		7,
		40369
	],
	"./is/_lib/localize/index.js": [
		40369,
		7,
		40369
	],
	"./is/_lib/match": [
		10932,
		7,
		10932
	],
	"./is/_lib/match/": [
		10932,
		7,
		10932
	],
	"./is/_lib/match/index": [
		10932,
		7,
		10932
	],
	"./is/_lib/match/index.js": [
		10932,
		7,
		10932
	],
	"./is/index": [
		38808,
		7,
		38808
	],
	"./is/index.d": [
		47580,
		9,
		47580
	],
	"./is/index.d.ts": [
		47580,
		9,
		47580
	],
	"./is/index.js": [
		38808,
		7,
		38808
	],
	"./is/index.js.flow": [
		8914,
		1,
		8914
	],
	"./is/package": [
		71136,
		3,
		71136
	],
	"./is/package.json": [
		71136,
		3,
		71136
	],
	"./it": [
		58288,
		9,
		58288
	],
	"./it/": [
		58288,
		9,
		58288
	],
	"./it/_lib/formatDistance": [
		87107,
		7,
		87107
	],
	"./it/_lib/formatDistance/": [
		87107,
		7,
		87107
	],
	"./it/_lib/formatDistance/index": [
		87107,
		7,
		87107
	],
	"./it/_lib/formatDistance/index.js": [
		87107,
		7,
		87107
	],
	"./it/_lib/formatLong": [
		99772,
		7,
		99772
	],
	"./it/_lib/formatLong/": [
		99772,
		7,
		99772
	],
	"./it/_lib/formatLong/index": [
		99772,
		7,
		99772
	],
	"./it/_lib/formatLong/index.js": [
		99772,
		7,
		99772
	],
	"./it/_lib/formatRelative": [
		24814,
		7,
		24814
	],
	"./it/_lib/formatRelative/": [
		24814,
		7,
		24814
	],
	"./it/_lib/formatRelative/index": [
		24814,
		7,
		24814
	],
	"./it/_lib/formatRelative/index.js": [
		24814,
		7,
		24814
	],
	"./it/_lib/localize": [
		15898,
		7,
		15898
	],
	"./it/_lib/localize/": [
		15898,
		7,
		15898
	],
	"./it/_lib/localize/index": [
		15898,
		7,
		15898
	],
	"./it/_lib/localize/index.js": [
		15898,
		7,
		15898
	],
	"./it/_lib/match": [
		38334,
		7,
		38334
	],
	"./it/_lib/match/": [
		38334,
		7,
		38334
	],
	"./it/_lib/match/index": [
		38334,
		7,
		38334
	],
	"./it/_lib/match/index.js": [
		38334,
		7,
		38334
	],
	"./it/index": [
		52150,
		7,
		52150
	],
	"./it/index.d": [
		26391,
		9,
		26391
	],
	"./it/index.d.ts": [
		26391,
		9,
		26391
	],
	"./it/index.js": [
		52150,
		7,
		52150
	],
	"./it/index.js.flow": [
		1916,
		1,
		1916
	],
	"./it/package": [
		44570,
		3,
		44570
	],
	"./it/package.json": [
		44570,
		3,
		44570
	],
	"./ja": [
		6814,
		9,
		6814
	],
	"./ja/": [
		6814,
		9,
		6814
	],
	"./ja/_lib/formatDistance": [
		44132,
		7,
		44132
	],
	"./ja/_lib/formatDistance/": [
		44132,
		7,
		44132
	],
	"./ja/_lib/formatDistance/index": [
		44132,
		7,
		44132
	],
	"./ja/_lib/formatDistance/index.js": [
		44132,
		7,
		44132
	],
	"./ja/_lib/formatLong": [
		35912,
		7,
		35912
	],
	"./ja/_lib/formatLong/": [
		35912,
		7,
		35912
	],
	"./ja/_lib/formatLong/index": [
		35912,
		7,
		35912
	],
	"./ja/_lib/formatLong/index.js": [
		35912,
		7,
		35912
	],
	"./ja/_lib/formatRelative": [
		86225,
		7,
		86225
	],
	"./ja/_lib/formatRelative/": [
		86225,
		7,
		86225
	],
	"./ja/_lib/formatRelative/index": [
		86225,
		7,
		86225
	],
	"./ja/_lib/formatRelative/index.js": [
		86225,
		7,
		86225
	],
	"./ja/_lib/localize": [
		66729,
		7,
		66729
	],
	"./ja/_lib/localize/": [
		66729,
		7,
		66729
	],
	"./ja/_lib/localize/index": [
		66729,
		7,
		66729
	],
	"./ja/_lib/localize/index.js": [
		66729,
		7,
		66729
	],
	"./ja/_lib/match": [
		46776,
		7,
		46776
	],
	"./ja/_lib/match/": [
		46776,
		7,
		46776
	],
	"./ja/_lib/match/index": [
		46776,
		7,
		46776
	],
	"./ja/_lib/match/index.js": [
		46776,
		7,
		46776
	],
	"./ja/index": [
		25528,
		7,
		25528
	],
	"./ja/index.d": [
		17364,
		9,
		17364
	],
	"./ja/index.d.ts": [
		17364,
		9,
		17364
	],
	"./ja/index.js": [
		25528,
		7,
		25528
	],
	"./ja/index.js.flow": [
		46699,
		1,
		46699
	],
	"./ja/package": [
		89712,
		3,
		89712
	],
	"./ja/package.json": [
		89712,
		3,
		89712
	],
	"./ka": [
		52396,
		9,
		52396
	],
	"./ka/": [
		52396,
		9,
		52396
	],
	"./ka/_lib/formatDistance": [
		73289,
		7,
		73289
	],
	"./ka/_lib/formatDistance/": [
		73289,
		7,
		73289
	],
	"./ka/_lib/formatDistance/index": [
		73289,
		7,
		73289
	],
	"./ka/_lib/formatDistance/index.js": [
		73289,
		7,
		73289
	],
	"./ka/_lib/formatLong": [
		78791,
		7,
		78791
	],
	"./ka/_lib/formatLong/": [
		78791,
		7,
		78791
	],
	"./ka/_lib/formatLong/index": [
		78791,
		7,
		78791
	],
	"./ka/_lib/formatLong/index.js": [
		78791,
		7,
		78791
	],
	"./ka/_lib/formatRelative": [
		15157,
		7,
		15157
	],
	"./ka/_lib/formatRelative/": [
		15157,
		7,
		15157
	],
	"./ka/_lib/formatRelative/index": [
		15157,
		7,
		15157
	],
	"./ka/_lib/formatRelative/index.js": [
		15157,
		7,
		15157
	],
	"./ka/_lib/localize": [
		18847,
		7,
		18847
	],
	"./ka/_lib/localize/": [
		18847,
		7,
		18847
	],
	"./ka/_lib/localize/index": [
		18847,
		7,
		18847
	],
	"./ka/_lib/localize/index.js": [
		18847,
		7,
		18847
	],
	"./ka/_lib/match": [
		28993,
		7,
		28993
	],
	"./ka/_lib/match/": [
		28993,
		7,
		28993
	],
	"./ka/_lib/match/index": [
		28993,
		7,
		28993
	],
	"./ka/_lib/match/index.js": [
		28993,
		7,
		28993
	],
	"./ka/index": [
		8849,
		7,
		8849
	],
	"./ka/index.d": [
		38067,
		9,
		38067
	],
	"./ka/index.d.ts": [
		38067,
		9,
		38067
	],
	"./ka/index.js": [
		8849,
		7,
		8849
	],
	"./ka/index.js.flow": [
		93894,
		1,
		93894
	],
	"./ka/package": [
		90933,
		3,
		90933
	],
	"./ka/package.json": [
		90933,
		3,
		90933
	],
	"./kk": [
		30311,
		9,
		30311
	],
	"./kk/": [
		30311,
		9,
		30311
	],
	"./kk/_lib/formatDistance": [
		10711,
		7,
		10711
	],
	"./kk/_lib/formatDistance/": [
		10711,
		7,
		10711
	],
	"./kk/_lib/formatDistance/index": [
		10711,
		7,
		10711
	],
	"./kk/_lib/formatDistance/index.js": [
		10711,
		7,
		10711
	],
	"./kk/_lib/formatLong": [
		61195,
		7,
		61195
	],
	"./kk/_lib/formatLong/": [
		61195,
		7,
		61195
	],
	"./kk/_lib/formatLong/index": [
		61195,
		7,
		61195
	],
	"./kk/_lib/formatLong/index.js": [
		61195,
		7,
		61195
	],
	"./kk/_lib/formatRelative": [
		47550,
		7,
		47550
	],
	"./kk/_lib/formatRelative/": [
		47550,
		7,
		47550
	],
	"./kk/_lib/formatRelative/index": [
		47550,
		7,
		47550
	],
	"./kk/_lib/formatRelative/index.js": [
		47550,
		7,
		47550
	],
	"./kk/_lib/localize": [
		45091,
		7,
		45091
	],
	"./kk/_lib/localize/": [
		45091,
		7,
		45091
	],
	"./kk/_lib/localize/index": [
		45091,
		7,
		45091
	],
	"./kk/_lib/localize/index.js": [
		45091,
		7,
		45091
	],
	"./kk/_lib/match": [
		19364,
		7,
		19364
	],
	"./kk/_lib/match/": [
		19364,
		7,
		19364
	],
	"./kk/_lib/match/index": [
		19364,
		7,
		19364
	],
	"./kk/_lib/match/index.js": [
		19364,
		7,
		19364
	],
	"./kk/index": [
		38249,
		7,
		38249,
		13842
	],
	"./kk/index.d": [
		38483,
		9,
		38483
	],
	"./kk/index.d.ts": [
		38483,
		9,
		38483
	],
	"./kk/index.js": [
		38249,
		7,
		38249,
		13842
	],
	"./kk/index.js.flow": [
		24296,
		1,
		24296
	],
	"./kk/package": [
		37617,
		3,
		37617
	],
	"./kk/package.json": [
		37617,
		3,
		37617
	],
	"./kn": [
		22374,
		9,
		22374
	],
	"./kn/": [
		22374,
		9,
		22374
	],
	"./kn/_lib/formatDistance": [
		54824,
		7,
		54824
	],
	"./kn/_lib/formatDistance/": [
		54824,
		7,
		54824
	],
	"./kn/_lib/formatDistance/index": [
		54824,
		7,
		54824
	],
	"./kn/_lib/formatDistance/index.js": [
		54824,
		7,
		54824
	],
	"./kn/_lib/formatLong": [
		64045,
		7,
		64045
	],
	"./kn/_lib/formatLong/": [
		64045,
		7,
		64045
	],
	"./kn/_lib/formatLong/index": [
		64045,
		7,
		64045
	],
	"./kn/_lib/formatLong/index.js": [
		64045,
		7,
		64045
	],
	"./kn/_lib/formatRelative": [
		47747,
		7,
		47747
	],
	"./kn/_lib/formatRelative/": [
		47747,
		7,
		47747
	],
	"./kn/_lib/formatRelative/index": [
		47747,
		7,
		47747
	],
	"./kn/_lib/formatRelative/index.js": [
		47747,
		7,
		47747
	],
	"./kn/_lib/localize": [
		31706,
		7,
		31706
	],
	"./kn/_lib/localize/": [
		31706,
		7,
		31706
	],
	"./kn/_lib/localize/index": [
		31706,
		7,
		31706
	],
	"./kn/_lib/localize/index.js": [
		31706,
		7,
		31706
	],
	"./kn/_lib/match": [
		7592,
		7,
		7592
	],
	"./kn/_lib/match/": [
		7592,
		7,
		7592
	],
	"./kn/_lib/match/index": [
		7592,
		7,
		7592
	],
	"./kn/_lib/match/index.js": [
		7592,
		7,
		7592
	],
	"./kn/index": [
		81032,
		7,
		81032
	],
	"./kn/index.d": [
		47223,
		9,
		47223
	],
	"./kn/index.d.ts": [
		47223,
		9,
		47223
	],
	"./kn/index.js": [
		81032,
		7,
		81032
	],
	"./kn/index.js.flow": [
		90359,
		1,
		90359
	],
	"./kn/package": [
		38942,
		3,
		38942
	],
	"./kn/package.json": [
		38942,
		3,
		38942
	],
	"./ko": [
		65184,
		9,
		65184
	],
	"./ko/": [
		65184,
		9,
		65184
	],
	"./ko/_lib/formatDistance": [
		89425,
		7,
		89425
	],
	"./ko/_lib/formatDistance/": [
		89425,
		7,
		89425
	],
	"./ko/_lib/formatDistance/index": [
		89425,
		7,
		89425
	],
	"./ko/_lib/formatDistance/index.js": [
		89425,
		7,
		89425
	],
	"./ko/_lib/formatLong": [
		32728,
		7,
		32728
	],
	"./ko/_lib/formatLong/": [
		32728,
		7,
		32728
	],
	"./ko/_lib/formatLong/index": [
		32728,
		7,
		32728
	],
	"./ko/_lib/formatLong/index.js": [
		32728,
		7,
		32728
	],
	"./ko/_lib/formatRelative": [
		31878,
		7,
		31878
	],
	"./ko/_lib/formatRelative/": [
		31878,
		7,
		31878
	],
	"./ko/_lib/formatRelative/index": [
		31878,
		7,
		31878
	],
	"./ko/_lib/formatRelative/index.js": [
		31878,
		7,
		31878
	],
	"./ko/_lib/localize": [
		53026,
		7,
		53026
	],
	"./ko/_lib/localize/": [
		53026,
		7,
		53026
	],
	"./ko/_lib/localize/index": [
		53026,
		7,
		53026
	],
	"./ko/_lib/localize/index.js": [
		53026,
		7,
		53026
	],
	"./ko/_lib/match": [
		96085,
		7,
		96085
	],
	"./ko/_lib/match/": [
		96085,
		7,
		96085
	],
	"./ko/_lib/match/index": [
		96085,
		7,
		96085
	],
	"./ko/_lib/match/index.js": [
		96085,
		7,
		96085
	],
	"./ko/index": [
		22291,
		7,
		22291
	],
	"./ko/index.d": [
		80772,
		9,
		80772
	],
	"./ko/index.d.ts": [
		80772,
		9,
		80772
	],
	"./ko/index.js": [
		22291,
		7,
		22291
	],
	"./ko/index.js.flow": [
		38722,
		1,
		38722
	],
	"./ko/package": [
		54065,
		3,
		54065
	],
	"./ko/package.json": [
		54065,
		3,
		54065
	],
	"./lb": [
		4049,
		9,
		4049
	],
	"./lb/": [
		4049,
		9,
		4049
	],
	"./lb/_lib/formatDistance": [
		17529,
		7,
		17529
	],
	"./lb/_lib/formatDistance/": [
		17529,
		7,
		17529
	],
	"./lb/_lib/formatDistance/index": [
		17529,
		7,
		17529
	],
	"./lb/_lib/formatDistance/index.js": [
		17529,
		7,
		17529
	],
	"./lb/_lib/formatLong": [
		66458,
		7,
		66458
	],
	"./lb/_lib/formatLong/": [
		66458,
		7,
		66458
	],
	"./lb/_lib/formatLong/index": [
		66458,
		7,
		66458
	],
	"./lb/_lib/formatLong/index.js": [
		66458,
		7,
		66458
	],
	"./lb/_lib/formatRelative": [
		98048,
		7,
		98048
	],
	"./lb/_lib/formatRelative/": [
		98048,
		7,
		98048
	],
	"./lb/_lib/formatRelative/index": [
		98048,
		7,
		98048
	],
	"./lb/_lib/formatRelative/index.js": [
		98048,
		7,
		98048
	],
	"./lb/_lib/localize": [
		10874,
		7,
		10874
	],
	"./lb/_lib/localize/": [
		10874,
		7,
		10874
	],
	"./lb/_lib/localize/index": [
		10874,
		7,
		10874
	],
	"./lb/_lib/localize/index.js": [
		10874,
		7,
		10874
	],
	"./lb/_lib/match": [
		47135,
		7,
		47135
	],
	"./lb/_lib/match/": [
		47135,
		7,
		47135
	],
	"./lb/_lib/match/index": [
		47135,
		7,
		47135
	],
	"./lb/_lib/match/index.js": [
		47135,
		7,
		47135
	],
	"./lb/index": [
		22329,
		7,
		22329
	],
	"./lb/index.d": [
		88330,
		9,
		88330
	],
	"./lb/index.d.ts": [
		88330,
		9,
		88330
	],
	"./lb/index.js": [
		22329,
		7,
		22329
	],
	"./lb/index.js.flow": [
		36274,
		1,
		36274
	],
	"./lb/package": [
		63604,
		3,
		63604
	],
	"./lb/package.json": [
		63604,
		3,
		63604
	],
	"./lt": [
		70212,
		9,
		70212
	],
	"./lt/": [
		70212,
		9,
		70212
	],
	"./lt/_lib/formatDistance": [
		71237,
		7,
		71237
	],
	"./lt/_lib/formatDistance/": [
		71237,
		7,
		71237
	],
	"./lt/_lib/formatDistance/index": [
		71237,
		7,
		71237
	],
	"./lt/_lib/formatDistance/index.js": [
		71237,
		7,
		71237
	],
	"./lt/_lib/formatLong": [
		36801,
		7,
		36801
	],
	"./lt/_lib/formatLong/": [
		36801,
		7,
		36801
	],
	"./lt/_lib/formatLong/index": [
		36801,
		7,
		36801
	],
	"./lt/_lib/formatLong/index.js": [
		36801,
		7,
		36801
	],
	"./lt/_lib/formatRelative": [
		25603,
		7,
		25603
	],
	"./lt/_lib/formatRelative/": [
		25603,
		7,
		25603
	],
	"./lt/_lib/formatRelative/index": [
		25603,
		7,
		25603
	],
	"./lt/_lib/formatRelative/index.js": [
		25603,
		7,
		25603
	],
	"./lt/_lib/localize": [
		18724,
		7,
		18724
	],
	"./lt/_lib/localize/": [
		18724,
		7,
		18724
	],
	"./lt/_lib/localize/index": [
		18724,
		7,
		18724
	],
	"./lt/_lib/localize/index.js": [
		18724,
		7,
		18724
	],
	"./lt/_lib/match": [
		24234,
		7,
		24234
	],
	"./lt/_lib/match/": [
		24234,
		7,
		24234
	],
	"./lt/_lib/match/index": [
		24234,
		7,
		24234
	],
	"./lt/_lib/match/index.js": [
		24234,
		7,
		24234
	],
	"./lt/index": [
		41590,
		7,
		41590
	],
	"./lt/index.d": [
		14372,
		9,
		14372
	],
	"./lt/index.d.ts": [
		14372,
		9,
		14372
	],
	"./lt/index.js": [
		41590,
		7,
		41590
	],
	"./lt/index.js.flow": [
		38949,
		1,
		38949
	],
	"./lt/package": [
		82125,
		3,
		82125
	],
	"./lt/package.json": [
		82125,
		3,
		82125
	],
	"./lv": [
		94320,
		9,
		94320
	],
	"./lv/": [
		94320,
		9,
		94320
	],
	"./lv/_lib/formatDistance": [
		15574,
		7,
		15574
	],
	"./lv/_lib/formatDistance/": [
		15574,
		7,
		15574
	],
	"./lv/_lib/formatDistance/index": [
		15574,
		7,
		15574
	],
	"./lv/_lib/formatDistance/index.js": [
		15574,
		7,
		15574
	],
	"./lv/_lib/formatLong": [
		44886,
		7,
		44886
	],
	"./lv/_lib/formatLong/": [
		44886,
		7,
		44886
	],
	"./lv/_lib/formatLong/index": [
		44886,
		7,
		44886
	],
	"./lv/_lib/formatLong/index.js": [
		44886,
		7,
		44886
	],
	"./lv/_lib/formatRelative": [
		35431,
		7,
		35431
	],
	"./lv/_lib/formatRelative/": [
		35431,
		7,
		35431
	],
	"./lv/_lib/formatRelative/index": [
		35431,
		7,
		35431
	],
	"./lv/_lib/formatRelative/index.js": [
		35431,
		7,
		35431
	],
	"./lv/_lib/localize": [
		7843,
		7,
		7843
	],
	"./lv/_lib/localize/": [
		7843,
		7,
		7843
	],
	"./lv/_lib/localize/index": [
		7843,
		7,
		7843
	],
	"./lv/_lib/localize/index.js": [
		7843,
		7,
		7843
	],
	"./lv/_lib/match": [
		34422,
		7,
		34422
	],
	"./lv/_lib/match/": [
		34422,
		7,
		34422
	],
	"./lv/_lib/match/index": [
		34422,
		7,
		34422
	],
	"./lv/_lib/match/index.js": [
		34422,
		7,
		34422
	],
	"./lv/index": [
		23060,
		7,
		23060
	],
	"./lv/index.d": [
		60988,
		9,
		60988
	],
	"./lv/index.d.ts": [
		60988,
		9,
		60988
	],
	"./lv/index.js": [
		23060,
		7,
		23060
	],
	"./lv/index.js.flow": [
		36634,
		1,
		36634
	],
	"./lv/package": [
		88819,
		3,
		88819
	],
	"./lv/package.json": [
		88819,
		3,
		88819
	],
	"./mk": [
		34090,
		9,
		34090
	],
	"./mk/": [
		34090,
		9,
		34090
	],
	"./mk/_lib/formatDistance": [
		56878,
		7,
		56878
	],
	"./mk/_lib/formatDistance/": [
		56878,
		7,
		56878
	],
	"./mk/_lib/formatDistance/index": [
		56878,
		7,
		56878
	],
	"./mk/_lib/formatDistance/index.js": [
		56878,
		7,
		56878
	],
	"./mk/_lib/formatLong": [
		12081,
		7,
		12081
	],
	"./mk/_lib/formatLong/": [
		12081,
		7,
		12081
	],
	"./mk/_lib/formatLong/index": [
		12081,
		7,
		12081
	],
	"./mk/_lib/formatLong/index.js": [
		12081,
		7,
		12081
	],
	"./mk/_lib/formatRelative": [
		60898,
		7,
		60898
	],
	"./mk/_lib/formatRelative/": [
		60898,
		7,
		60898
	],
	"./mk/_lib/formatRelative/index": [
		60898,
		7,
		60898
	],
	"./mk/_lib/formatRelative/index.js": [
		60898,
		7,
		60898
	],
	"./mk/_lib/localize": [
		57454,
		7,
		57454
	],
	"./mk/_lib/localize/": [
		57454,
		7,
		57454
	],
	"./mk/_lib/localize/index": [
		57454,
		7,
		57454
	],
	"./mk/_lib/localize/index.js": [
		57454,
		7,
		57454
	],
	"./mk/_lib/match": [
		99603,
		7,
		99603
	],
	"./mk/_lib/match/": [
		99603,
		7,
		99603
	],
	"./mk/_lib/match/index": [
		99603,
		7,
		99603
	],
	"./mk/_lib/match/index.js": [
		99603,
		7,
		99603
	],
	"./mk/index": [
		4811,
		7,
		4811
	],
	"./mk/index.d": [
		92368,
		9,
		92368
	],
	"./mk/index.d.ts": [
		92368,
		9,
		92368
	],
	"./mk/index.js": [
		4811,
		7,
		4811
	],
	"./mk/index.js.flow": [
		77147,
		1,
		77147
	],
	"./mk/package": [
		77818,
		3,
		77818
	],
	"./mk/package.json": [
		77818,
		3,
		77818
	],
	"./mn": [
		22819,
		9,
		22819
	],
	"./mn/": [
		22819,
		9,
		22819
	],
	"./mn/_lib/formatDistance": [
		65985,
		7,
		65985
	],
	"./mn/_lib/formatDistance/": [
		65985,
		7,
		65985
	],
	"./mn/_lib/formatDistance/index": [
		65985,
		7,
		65985
	],
	"./mn/_lib/formatDistance/index.js": [
		65985,
		7,
		65985
	],
	"./mn/_lib/formatLong": [
		44728,
		7,
		44728
	],
	"./mn/_lib/formatLong/": [
		44728,
		7,
		44728
	],
	"./mn/_lib/formatLong/index": [
		44728,
		7,
		44728
	],
	"./mn/_lib/formatLong/index.js": [
		44728,
		7,
		44728
	],
	"./mn/_lib/formatRelative": [
		96246,
		7,
		96246
	],
	"./mn/_lib/formatRelative/": [
		96246,
		7,
		96246
	],
	"./mn/_lib/formatRelative/index": [
		96246,
		7,
		96246
	],
	"./mn/_lib/formatRelative/index.js": [
		96246,
		7,
		96246
	],
	"./mn/_lib/localize": [
		64613,
		7,
		64613
	],
	"./mn/_lib/localize/": [
		64613,
		7,
		64613
	],
	"./mn/_lib/localize/index": [
		64613,
		7,
		64613
	],
	"./mn/_lib/localize/index.js": [
		64613,
		7,
		64613
	],
	"./mn/_lib/match": [
		39792,
		7,
		39792
	],
	"./mn/_lib/match/": [
		39792,
		7,
		39792
	],
	"./mn/_lib/match/index": [
		39792,
		7,
		39792
	],
	"./mn/_lib/match/index.js": [
		39792,
		7,
		39792
	],
	"./mn/index": [
		36328,
		7,
		36328
	],
	"./mn/index.d": [
		86145,
		9,
		86145
	],
	"./mn/index.d.ts": [
		86145,
		9,
		86145
	],
	"./mn/index.js": [
		36328,
		7,
		36328
	],
	"./mn/index.js.flow": [
		18094,
		1,
		18094
	],
	"./mn/package": [
		10023,
		3,
		10023
	],
	"./mn/package.json": [
		10023,
		3,
		10023
	],
	"./ms": [
		10127,
		9,
		10127
	],
	"./ms/": [
		10127,
		9,
		10127
	],
	"./ms/_lib/formatDistance": [
		20918,
		7,
		20918
	],
	"./ms/_lib/formatDistance/": [
		20918,
		7,
		20918
	],
	"./ms/_lib/formatDistance/index": [
		20918,
		7,
		20918
	],
	"./ms/_lib/formatDistance/index.js": [
		20918,
		7,
		20918
	],
	"./ms/_lib/formatLong": [
		49284,
		7,
		49284
	],
	"./ms/_lib/formatLong/": [
		49284,
		7,
		49284
	],
	"./ms/_lib/formatLong/index": [
		49284,
		7,
		49284
	],
	"./ms/_lib/formatLong/index.js": [
		49284,
		7,
		49284
	],
	"./ms/_lib/formatRelative": [
		16141,
		7,
		16141
	],
	"./ms/_lib/formatRelative/": [
		16141,
		7,
		16141
	],
	"./ms/_lib/formatRelative/index": [
		16141,
		7,
		16141
	],
	"./ms/_lib/formatRelative/index.js": [
		16141,
		7,
		16141
	],
	"./ms/_lib/localize": [
		87638,
		7,
		87638
	],
	"./ms/_lib/localize/": [
		87638,
		7,
		87638
	],
	"./ms/_lib/localize/index": [
		87638,
		7,
		87638
	],
	"./ms/_lib/localize/index.js": [
		87638,
		7,
		87638
	],
	"./ms/_lib/match": [
		56203,
		7,
		56203
	],
	"./ms/_lib/match/": [
		56203,
		7,
		56203
	],
	"./ms/_lib/match/index": [
		56203,
		7,
		56203
	],
	"./ms/_lib/match/index.js": [
		56203,
		7,
		56203
	],
	"./ms/index": [
		79792,
		7,
		79792
	],
	"./ms/index.d": [
		42415,
		9,
		42415
	],
	"./ms/index.d.ts": [
		42415,
		9,
		42415
	],
	"./ms/index.js": [
		79792,
		7,
		79792
	],
	"./ms/index.js.flow": [
		17941,
		1,
		17941
	],
	"./ms/package": [
		79249,
		3,
		79249
	],
	"./ms/package.json": [
		79249,
		3,
		79249
	],
	"./mt": [
		95448,
		9,
		95448
	],
	"./mt/": [
		95448,
		9,
		95448
	],
	"./mt/_lib/formatDistance": [
		93022,
		7,
		93022
	],
	"./mt/_lib/formatDistance/": [
		93022,
		7,
		93022
	],
	"./mt/_lib/formatDistance/index": [
		93022,
		7,
		93022
	],
	"./mt/_lib/formatDistance/index.js": [
		93022,
		7,
		93022
	],
	"./mt/_lib/formatLong": [
		9182,
		7,
		9182
	],
	"./mt/_lib/formatLong/": [
		9182,
		7,
		9182
	],
	"./mt/_lib/formatLong/index": [
		9182,
		7,
		9182
	],
	"./mt/_lib/formatLong/index.js": [
		9182,
		7,
		9182
	],
	"./mt/_lib/formatRelative": [
		51701,
		7,
		51701
	],
	"./mt/_lib/formatRelative/": [
		51701,
		7,
		51701
	],
	"./mt/_lib/formatRelative/index": [
		51701,
		7,
		51701
	],
	"./mt/_lib/formatRelative/index.js": [
		51701,
		7,
		51701
	],
	"./mt/_lib/localize": [
		37693,
		7,
		37693
	],
	"./mt/_lib/localize/": [
		37693,
		7,
		37693
	],
	"./mt/_lib/localize/index": [
		37693,
		7,
		37693
	],
	"./mt/_lib/localize/index.js": [
		37693,
		7,
		37693
	],
	"./mt/_lib/match": [
		17449,
		7,
		17449
	],
	"./mt/_lib/match/": [
		17449,
		7,
		17449
	],
	"./mt/_lib/match/index": [
		17449,
		7,
		17449
	],
	"./mt/_lib/match/index.js": [
		17449,
		7,
		17449
	],
	"./mt/index": [
		39255,
		7,
		39255
	],
	"./mt/index.d": [
		69070,
		9,
		69070
	],
	"./mt/index.d.ts": [
		69070,
		9,
		69070
	],
	"./mt/index.js": [
		39255,
		7,
		39255
	],
	"./mt/index.js.flow": [
		37829,
		1,
		37829
	],
	"./mt/package": [
		6934,
		3,
		6934
	],
	"./mt/package.json": [
		6934,
		3,
		6934
	],
	"./nb": [
		4202,
		9,
		4202
	],
	"./nb/": [
		4202,
		9,
		4202
	],
	"./nb/_lib/formatDistance": [
		48387,
		7,
		48387
	],
	"./nb/_lib/formatDistance/": [
		48387,
		7,
		48387
	],
	"./nb/_lib/formatDistance/index": [
		48387,
		7,
		48387
	],
	"./nb/_lib/formatDistance/index.js": [
		48387,
		7,
		48387
	],
	"./nb/_lib/formatLong": [
		70372,
		7,
		70372
	],
	"./nb/_lib/formatLong/": [
		70372,
		7,
		70372
	],
	"./nb/_lib/formatLong/index": [
		70372,
		7,
		70372
	],
	"./nb/_lib/formatLong/index.js": [
		70372,
		7,
		70372
	],
	"./nb/_lib/formatRelative": [
		35312,
		7,
		35312
	],
	"./nb/_lib/formatRelative/": [
		35312,
		7,
		35312
	],
	"./nb/_lib/formatRelative/index": [
		35312,
		7,
		35312
	],
	"./nb/_lib/formatRelative/index.js": [
		35312,
		7,
		35312
	],
	"./nb/_lib/localize": [
		83730,
		7,
		83730
	],
	"./nb/_lib/localize/": [
		83730,
		7,
		83730
	],
	"./nb/_lib/localize/index": [
		83730,
		7,
		83730
	],
	"./nb/_lib/localize/index.js": [
		83730,
		7,
		83730
	],
	"./nb/_lib/match": [
		12014,
		7,
		12014
	],
	"./nb/_lib/match/": [
		12014,
		7,
		12014
	],
	"./nb/_lib/match/index": [
		12014,
		7,
		12014
	],
	"./nb/_lib/match/index.js": [
		12014,
		7,
		12014
	],
	"./nb/index": [
		73553,
		7,
		73553
	],
	"./nb/index.d": [
		5412,
		9,
		5412
	],
	"./nb/index.d.ts": [
		5412,
		9,
		5412
	],
	"./nb/index.js": [
		73553,
		7,
		73553
	],
	"./nb/index.js.flow": [
		20209,
		1,
		20209
	],
	"./nb/package": [
		63691,
		3,
		63691
	],
	"./nb/package.json": [
		63691,
		3,
		63691
	],
	"./nl": [
		52559,
		9,
		52559
	],
	"./nl-BE": [
		41732,
		9,
		41732
	],
	"./nl-BE/": [
		41732,
		9,
		41732
	],
	"./nl-BE/_lib/formatDistance": [
		21455,
		7,
		21455
	],
	"./nl-BE/_lib/formatDistance/": [
		21455,
		7,
		21455
	],
	"./nl-BE/_lib/formatDistance/index": [
		21455,
		7,
		21455
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		21455,
		7,
		21455
	],
	"./nl-BE/_lib/formatLong": [
		68099,
		7,
		68099
	],
	"./nl-BE/_lib/formatLong/": [
		68099,
		7,
		68099
	],
	"./nl-BE/_lib/formatLong/index": [
		68099,
		7,
		68099
	],
	"./nl-BE/_lib/formatLong/index.js": [
		68099,
		7,
		68099
	],
	"./nl-BE/_lib/formatRelative": [
		65965,
		7,
		65965
	],
	"./nl-BE/_lib/formatRelative/": [
		65965,
		7,
		65965
	],
	"./nl-BE/_lib/formatRelative/index": [
		65965,
		7,
		65965
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		65965,
		7,
		65965
	],
	"./nl-BE/_lib/localize": [
		42724,
		7,
		42724
	],
	"./nl-BE/_lib/localize/": [
		42724,
		7,
		42724
	],
	"./nl-BE/_lib/localize/index": [
		42724,
		7,
		42724
	],
	"./nl-BE/_lib/localize/index.js": [
		42724,
		7,
		42724
	],
	"./nl-BE/_lib/match": [
		10808,
		7,
		10808
	],
	"./nl-BE/_lib/match/": [
		10808,
		7,
		10808
	],
	"./nl-BE/_lib/match/index": [
		10808,
		7,
		10808
	],
	"./nl-BE/_lib/match/index.js": [
		10808,
		7,
		10808
	],
	"./nl-BE/index": [
		33494,
		7,
		33494
	],
	"./nl-BE/index.d": [
		41292,
		9,
		41292
	],
	"./nl-BE/index.d.ts": [
		41292,
		9,
		41292
	],
	"./nl-BE/index.js": [
		33494,
		7,
		33494
	],
	"./nl-BE/index.js.flow": [
		68550,
		1,
		68550
	],
	"./nl-BE/package": [
		92797,
		3,
		92797
	],
	"./nl-BE/package.json": [
		92797,
		3,
		92797
	],
	"./nl/": [
		52559,
		9,
		52559
	],
	"./nl/_lib/formatDistance": [
		50172,
		7,
		50172
	],
	"./nl/_lib/formatDistance/": [
		50172,
		7,
		50172
	],
	"./nl/_lib/formatDistance/index": [
		50172,
		7,
		50172
	],
	"./nl/_lib/formatDistance/index.js": [
		50172,
		7,
		50172
	],
	"./nl/_lib/formatLong": [
		68773,
		7,
		68773
	],
	"./nl/_lib/formatLong/": [
		68773,
		7,
		68773
	],
	"./nl/_lib/formatLong/index": [
		68773,
		7,
		68773
	],
	"./nl/_lib/formatLong/index.js": [
		68773,
		7,
		68773
	],
	"./nl/_lib/formatRelative": [
		83962,
		7,
		83962
	],
	"./nl/_lib/formatRelative/": [
		83962,
		7,
		83962
	],
	"./nl/_lib/formatRelative/index": [
		83962,
		7,
		83962
	],
	"./nl/_lib/formatRelative/index.js": [
		83962,
		7,
		83962
	],
	"./nl/_lib/localize": [
		97108,
		7,
		97108
	],
	"./nl/_lib/localize/": [
		97108,
		7,
		97108
	],
	"./nl/_lib/localize/index": [
		97108,
		7,
		97108
	],
	"./nl/_lib/localize/index.js": [
		97108,
		7,
		97108
	],
	"./nl/_lib/match": [
		44545,
		7,
		44545
	],
	"./nl/_lib/match/": [
		44545,
		7,
		44545
	],
	"./nl/_lib/match/index": [
		44545,
		7,
		44545
	],
	"./nl/_lib/match/index.js": [
		44545,
		7,
		44545
	],
	"./nl/index": [
		86899,
		7,
		86899
	],
	"./nl/index.d": [
		78610,
		9,
		78610
	],
	"./nl/index.d.ts": [
		78610,
		9,
		78610
	],
	"./nl/index.js": [
		86899,
		7,
		86899
	],
	"./nl/index.js.flow": [
		6667,
		1,
		6667
	],
	"./nl/package": [
		68791,
		3,
		68791
	],
	"./nl/package.json": [
		68791,
		3,
		68791
	],
	"./nn": [
		86621,
		9,
		86621
	],
	"./nn/": [
		86621,
		9,
		86621
	],
	"./nn/_lib/formatDistance": [
		98952,
		7,
		98952
	],
	"./nn/_lib/formatDistance/": [
		98952,
		7,
		98952
	],
	"./nn/_lib/formatDistance/index": [
		98952,
		7,
		98952
	],
	"./nn/_lib/formatDistance/index.js": [
		98952,
		7,
		98952
	],
	"./nn/_lib/formatLong": [
		84755,
		7,
		84755
	],
	"./nn/_lib/formatLong/": [
		84755,
		7,
		84755
	],
	"./nn/_lib/formatLong/index": [
		84755,
		7,
		84755
	],
	"./nn/_lib/formatLong/index.js": [
		84755,
		7,
		84755
	],
	"./nn/_lib/formatRelative": [
		52146,
		7,
		52146
	],
	"./nn/_lib/formatRelative/": [
		52146,
		7,
		52146
	],
	"./nn/_lib/formatRelative/index": [
		52146,
		7,
		52146
	],
	"./nn/_lib/formatRelative/index.js": [
		52146,
		7,
		52146
	],
	"./nn/_lib/localize": [
		50832,
		7,
		50832
	],
	"./nn/_lib/localize/": [
		50832,
		7,
		50832
	],
	"./nn/_lib/localize/index": [
		50832,
		7,
		50832
	],
	"./nn/_lib/localize/index.js": [
		50832,
		7,
		50832
	],
	"./nn/_lib/match": [
		15112,
		7,
		15112
	],
	"./nn/_lib/match/": [
		15112,
		7,
		15112
	],
	"./nn/_lib/match/index": [
		15112,
		7,
		15112
	],
	"./nn/_lib/match/index.js": [
		15112,
		7,
		15112
	],
	"./nn/index": [
		8667,
		7,
		8667
	],
	"./nn/index.d": [
		46006,
		9,
		46006
	],
	"./nn/index.d.ts": [
		46006,
		9,
		46006
	],
	"./nn/index.js": [
		8667,
		7,
		8667
	],
	"./nn/index.js.flow": [
		2219,
		1,
		2219
	],
	"./nn/package": [
		46111,
		3,
		46111
	],
	"./nn/package.json": [
		46111,
		3,
		46111
	],
	"./package": [
		87852,
		3,
		87852
	],
	"./package.json": [
		87852,
		3,
		87852
	],
	"./pl": [
		66240,
		9,
		66240
	],
	"./pl/": [
		66240,
		9,
		66240
	],
	"./pl/_lib/formatDistance": [
		11794,
		7,
		11794
	],
	"./pl/_lib/formatDistance/": [
		11794,
		7,
		11794
	],
	"./pl/_lib/formatDistance/index": [
		11794,
		7,
		11794
	],
	"./pl/_lib/formatDistance/index.js": [
		11794,
		7,
		11794
	],
	"./pl/_lib/formatLong": [
		91016,
		7,
		91016
	],
	"./pl/_lib/formatLong/": [
		91016,
		7,
		91016
	],
	"./pl/_lib/formatLong/index": [
		91016,
		7,
		91016
	],
	"./pl/_lib/formatLong/index.js": [
		91016,
		7,
		91016
	],
	"./pl/_lib/formatRelative": [
		95497,
		7,
		95497
	],
	"./pl/_lib/formatRelative/": [
		95497,
		7,
		95497
	],
	"./pl/_lib/formatRelative/index": [
		95497,
		7,
		95497
	],
	"./pl/_lib/formatRelative/index.js": [
		95497,
		7,
		95497
	],
	"./pl/_lib/localize": [
		93792,
		7,
		93792
	],
	"./pl/_lib/localize/": [
		93792,
		7,
		93792
	],
	"./pl/_lib/localize/index": [
		93792,
		7,
		93792
	],
	"./pl/_lib/localize/index.js": [
		93792,
		7,
		93792
	],
	"./pl/_lib/match": [
		28003,
		7,
		28003
	],
	"./pl/_lib/match/": [
		28003,
		7,
		28003
	],
	"./pl/_lib/match/index": [
		28003,
		7,
		28003
	],
	"./pl/_lib/match/index.js": [
		28003,
		7,
		28003
	],
	"./pl/index": [
		8929,
		7,
		8929
	],
	"./pl/index.d": [
		42900,
		9,
		42900
	],
	"./pl/index.d.ts": [
		42900,
		9,
		42900
	],
	"./pl/index.js": [
		8929,
		7,
		8929
	],
	"./pl/index.js.flow": [
		65953,
		1,
		65953
	],
	"./pl/package": [
		69261,
		3,
		69261
	],
	"./pl/package.json": [
		69261,
		3,
		69261
	],
	"./pt": [
		92786,
		9,
		92786
	],
	"./pt-BR": [
		84781,
		9,
		84781
	],
	"./pt-BR/": [
		84781,
		9,
		84781
	],
	"./pt-BR/_lib/formatDistance": [
		64586,
		7,
		64586
	],
	"./pt-BR/_lib/formatDistance/": [
		64586,
		7,
		64586
	],
	"./pt-BR/_lib/formatDistance/index": [
		64586,
		7,
		64586
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		64586,
		7,
		64586
	],
	"./pt-BR/_lib/formatLong": [
		32924,
		7,
		32924
	],
	"./pt-BR/_lib/formatLong/": [
		32924,
		7,
		32924
	],
	"./pt-BR/_lib/formatLong/index": [
		32924,
		7,
		32924
	],
	"./pt-BR/_lib/formatLong/index.js": [
		32924,
		7,
		32924
	],
	"./pt-BR/_lib/formatRelative": [
		5353,
		7,
		5353
	],
	"./pt-BR/_lib/formatRelative/": [
		5353,
		7,
		5353
	],
	"./pt-BR/_lib/formatRelative/index": [
		5353,
		7,
		5353
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		5353,
		7,
		5353
	],
	"./pt-BR/_lib/localize": [
		9922,
		7,
		9922
	],
	"./pt-BR/_lib/localize/": [
		9922,
		7,
		9922
	],
	"./pt-BR/_lib/localize/index": [
		9922,
		7,
		9922
	],
	"./pt-BR/_lib/localize/index.js": [
		9922,
		7,
		9922
	],
	"./pt-BR/_lib/match": [
		31949,
		7,
		31949
	],
	"./pt-BR/_lib/match/": [
		31949,
		7,
		31949
	],
	"./pt-BR/_lib/match/index": [
		31949,
		7,
		31949
	],
	"./pt-BR/_lib/match/index.js": [
		31949,
		7,
		31949
	],
	"./pt-BR/index": [
		44798,
		7,
		44798
	],
	"./pt-BR/index.d": [
		38031,
		9,
		38031
	],
	"./pt-BR/index.d.ts": [
		38031,
		9,
		38031
	],
	"./pt-BR/index.js": [
		44798,
		7,
		44798
	],
	"./pt-BR/index.js.flow": [
		30831,
		1,
		30831
	],
	"./pt-BR/package": [
		50589,
		3,
		50589
	],
	"./pt-BR/package.json": [
		50589,
		3,
		50589
	],
	"./pt/": [
		92786,
		9,
		92786
	],
	"./pt/_lib/formatDistance": [
		39039,
		7,
		39039
	],
	"./pt/_lib/formatDistance/": [
		39039,
		7,
		39039
	],
	"./pt/_lib/formatDistance/index": [
		39039,
		7,
		39039
	],
	"./pt/_lib/formatDistance/index.js": [
		39039,
		7,
		39039
	],
	"./pt/_lib/formatLong": [
		7369,
		7,
		7369
	],
	"./pt/_lib/formatLong/": [
		7369,
		7,
		7369
	],
	"./pt/_lib/formatLong/index": [
		7369,
		7,
		7369
	],
	"./pt/_lib/formatLong/index.js": [
		7369,
		7,
		7369
	],
	"./pt/_lib/formatRelative": [
		9482,
		7,
		9482
	],
	"./pt/_lib/formatRelative/": [
		9482,
		7,
		9482
	],
	"./pt/_lib/formatRelative/index": [
		9482,
		7,
		9482
	],
	"./pt/_lib/formatRelative/index.js": [
		9482,
		7,
		9482
	],
	"./pt/_lib/localize": [
		81972,
		7,
		81972
	],
	"./pt/_lib/localize/": [
		81972,
		7,
		81972
	],
	"./pt/_lib/localize/index": [
		81972,
		7,
		81972
	],
	"./pt/_lib/localize/index.js": [
		81972,
		7,
		81972
	],
	"./pt/_lib/match": [
		13722,
		7,
		13722
	],
	"./pt/_lib/match/": [
		13722,
		7,
		13722
	],
	"./pt/_lib/match/index": [
		13722,
		7,
		13722
	],
	"./pt/_lib/match/index.js": [
		13722,
		7,
		13722
	],
	"./pt/index": [
		70101,
		7,
		70101
	],
	"./pt/index.d": [
		51683,
		9,
		51683
	],
	"./pt/index.d.ts": [
		51683,
		9,
		51683
	],
	"./pt/index.js": [
		70101,
		7,
		70101
	],
	"./pt/index.js.flow": [
		8134,
		1,
		8134
	],
	"./pt/package": [
		3048,
		3,
		3048
	],
	"./pt/package.json": [
		3048,
		3,
		3048
	],
	"./ro": [
		62972,
		9,
		62972
	],
	"./ro/": [
		62972,
		9,
		62972
	],
	"./ro/_lib/formatDistance": [
		13352,
		7,
		13352
	],
	"./ro/_lib/formatDistance/": [
		13352,
		7,
		13352
	],
	"./ro/_lib/formatDistance/index": [
		13352,
		7,
		13352
	],
	"./ro/_lib/formatDistance/index.js": [
		13352,
		7,
		13352
	],
	"./ro/_lib/formatLong": [
		54370,
		7,
		54370
	],
	"./ro/_lib/formatLong/": [
		54370,
		7,
		54370
	],
	"./ro/_lib/formatLong/index": [
		54370,
		7,
		54370
	],
	"./ro/_lib/formatLong/index.js": [
		54370,
		7,
		54370
	],
	"./ro/_lib/formatRelative": [
		86348,
		7,
		86348
	],
	"./ro/_lib/formatRelative/": [
		86348,
		7,
		86348
	],
	"./ro/_lib/formatRelative/index": [
		86348,
		7,
		86348
	],
	"./ro/_lib/formatRelative/index.js": [
		86348,
		7,
		86348
	],
	"./ro/_lib/localize": [
		91515,
		7,
		91515
	],
	"./ro/_lib/localize/": [
		91515,
		7,
		91515
	],
	"./ro/_lib/localize/index": [
		91515,
		7,
		91515
	],
	"./ro/_lib/localize/index.js": [
		91515,
		7,
		91515
	],
	"./ro/_lib/match": [
		94225,
		7,
		94225
	],
	"./ro/_lib/match/": [
		94225,
		7,
		94225
	],
	"./ro/_lib/match/index": [
		94225,
		7,
		94225
	],
	"./ro/_lib/match/index.js": [
		94225,
		7,
		94225
	],
	"./ro/index": [
		77844,
		7,
		77844
	],
	"./ro/index.d": [
		74034,
		9,
		74034
	],
	"./ro/index.d.ts": [
		74034,
		9,
		74034
	],
	"./ro/index.js": [
		77844,
		7,
		77844
	],
	"./ro/index.js.flow": [
		65539,
		1,
		65539
	],
	"./ro/package": [
		78573,
		3,
		78573
	],
	"./ro/package.json": [
		78573,
		3,
		78573
	],
	"./ru": [
		30175,
		9,
		30175
	],
	"./ru/": [
		30175,
		9,
		30175
	],
	"./ru/_lib/formatDistance": [
		47601,
		7,
		47601
	],
	"./ru/_lib/formatDistance/": [
		47601,
		7,
		47601
	],
	"./ru/_lib/formatDistance/index": [
		47601,
		7,
		47601
	],
	"./ru/_lib/formatDistance/index.js": [
		47601,
		7,
		47601
	],
	"./ru/_lib/formatLong": [
		3828,
		7,
		3828
	],
	"./ru/_lib/formatLong/": [
		3828,
		7,
		3828
	],
	"./ru/_lib/formatLong/index": [
		3828,
		7,
		3828
	],
	"./ru/_lib/formatLong/index.js": [
		3828,
		7,
		3828
	],
	"./ru/_lib/formatRelative": [
		79689,
		7,
		79689
	],
	"./ru/_lib/formatRelative/": [
		79689,
		7,
		79689
	],
	"./ru/_lib/formatRelative/index": [
		79689,
		7,
		79689
	],
	"./ru/_lib/formatRelative/index.js": [
		79689,
		7,
		79689
	],
	"./ru/_lib/localize": [
		35376,
		7,
		35376
	],
	"./ru/_lib/localize/": [
		35376,
		7,
		35376
	],
	"./ru/_lib/localize/index": [
		35376,
		7,
		35376
	],
	"./ru/_lib/localize/index.js": [
		35376,
		7,
		35376
	],
	"./ru/_lib/match": [
		24783,
		7,
		24783
	],
	"./ru/_lib/match/": [
		24783,
		7,
		24783
	],
	"./ru/_lib/match/index": [
		24783,
		7,
		24783
	],
	"./ru/_lib/match/index.js": [
		24783,
		7,
		24783
	],
	"./ru/index": [
		7243,
		7,
		7243,
		59238
	],
	"./ru/index.d": [
		93868,
		9,
		93868
	],
	"./ru/index.d.ts": [
		93868,
		9,
		93868
	],
	"./ru/index.js": [
		7243,
		7,
		7243,
		59238
	],
	"./ru/index.js.flow": [
		47864,
		1,
		47864
	],
	"./ru/package": [
		30004,
		3,
		30004
	],
	"./ru/package.json": [
		30004,
		3,
		30004
	],
	"./sk": [
		20166,
		9,
		20166
	],
	"./sk/": [
		20166,
		9,
		20166
	],
	"./sk/_lib/formatDistance": [
		70127,
		7,
		70127
	],
	"./sk/_lib/formatDistance/": [
		70127,
		7,
		70127
	],
	"./sk/_lib/formatDistance/index": [
		70127,
		7,
		70127
	],
	"./sk/_lib/formatDistance/index.js": [
		70127,
		7,
		70127
	],
	"./sk/_lib/formatLong": [
		99956,
		7,
		99956
	],
	"./sk/_lib/formatLong/": [
		99956,
		7,
		99956
	],
	"./sk/_lib/formatLong/index": [
		99956,
		7,
		99956
	],
	"./sk/_lib/formatLong/index.js": [
		99956,
		7,
		99956
	],
	"./sk/_lib/formatRelative": [
		89784,
		7,
		89784
	],
	"./sk/_lib/formatRelative/": [
		89784,
		7,
		89784
	],
	"./sk/_lib/formatRelative/index": [
		89784,
		7,
		89784
	],
	"./sk/_lib/formatRelative/index.js": [
		89784,
		7,
		89784
	],
	"./sk/_lib/localize": [
		93734,
		7,
		93734
	],
	"./sk/_lib/localize/": [
		93734,
		7,
		93734
	],
	"./sk/_lib/localize/index": [
		93734,
		7,
		93734
	],
	"./sk/_lib/localize/index.js": [
		93734,
		7,
		93734
	],
	"./sk/_lib/match": [
		81912,
		7,
		16345
	],
	"./sk/_lib/match/": [
		81912,
		7,
		16345
	],
	"./sk/_lib/match/index": [
		81912,
		7,
		16345
	],
	"./sk/_lib/match/index.js": [
		81912,
		7,
		16345
	],
	"./sk/index": [
		21544,
		7,
		21544
	],
	"./sk/index.d": [
		16505,
		9,
		70163
	],
	"./sk/index.d.ts": [
		16505,
		9,
		70163
	],
	"./sk/index.js": [
		21544,
		7,
		21544
	],
	"./sk/index.js.flow": [
		34084,
		1,
		34084
	],
	"./sk/package": [
		64262,
		3,
		64262
	],
	"./sk/package.json": [
		64262,
		3,
		64262
	],
	"./sl": [
		2869,
		9,
		2869
	],
	"./sl/": [
		2869,
		9,
		2869
	],
	"./sl/_lib/formatDistance": [
		27012,
		7,
		27012
	],
	"./sl/_lib/formatDistance/": [
		27012,
		7,
		27012
	],
	"./sl/_lib/formatDistance/index": [
		27012,
		7,
		27012
	],
	"./sl/_lib/formatDistance/index.js": [
		27012,
		7,
		27012
	],
	"./sl/_lib/formatLong": [
		33848,
		7,
		33848
	],
	"./sl/_lib/formatLong/": [
		33848,
		7,
		33848
	],
	"./sl/_lib/formatLong/index": [
		33848,
		7,
		33848
	],
	"./sl/_lib/formatLong/index.js": [
		33848,
		7,
		33848
	],
	"./sl/_lib/formatRelative": [
		39895,
		7,
		39895
	],
	"./sl/_lib/formatRelative/": [
		39895,
		7,
		39895
	],
	"./sl/_lib/formatRelative/index": [
		39895,
		7,
		39895
	],
	"./sl/_lib/formatRelative/index.js": [
		39895,
		7,
		39895
	],
	"./sl/_lib/localize": [
		58722,
		7,
		58722
	],
	"./sl/_lib/localize/": [
		58722,
		7,
		58722
	],
	"./sl/_lib/localize/index": [
		58722,
		7,
		58722
	],
	"./sl/_lib/localize/index.js": [
		58722,
		7,
		58722
	],
	"./sl/_lib/match": [
		41325,
		7,
		41325
	],
	"./sl/_lib/match/": [
		41325,
		7,
		41325
	],
	"./sl/_lib/match/index": [
		41325,
		7,
		41325
	],
	"./sl/_lib/match/index.js": [
		41325,
		7,
		41325
	],
	"./sl/index": [
		52138,
		7,
		52138
	],
	"./sl/index.d": [
		83885,
		9,
		83885
	],
	"./sl/index.d.ts": [
		83885,
		9,
		83885
	],
	"./sl/index.js": [
		52138,
		7,
		52138
	],
	"./sl/index.js.flow": [
		37378,
		1,
		37378
	],
	"./sl/package": [
		96286,
		3,
		96286
	],
	"./sl/package.json": [
		96286,
		3,
		96286
	],
	"./sq": [
		65317,
		9,
		65317
	],
	"./sq/": [
		65317,
		9,
		65317
	],
	"./sq/_lib/formatDistance": [
		84638,
		7,
		84638
	],
	"./sq/_lib/formatDistance/": [
		84638,
		7,
		84638
	],
	"./sq/_lib/formatDistance/index": [
		84638,
		7,
		84638
	],
	"./sq/_lib/formatDistance/index.js": [
		84638,
		7,
		84638
	],
	"./sq/_lib/formatLong": [
		35992,
		7,
		35992
	],
	"./sq/_lib/formatLong/": [
		35992,
		7,
		35992
	],
	"./sq/_lib/formatLong/index": [
		35992,
		7,
		35992
	],
	"./sq/_lib/formatLong/index.js": [
		35992,
		7,
		35992
	],
	"./sq/_lib/formatRelative": [
		15614,
		7,
		15614
	],
	"./sq/_lib/formatRelative/": [
		15614,
		7,
		15614
	],
	"./sq/_lib/formatRelative/index": [
		15614,
		7,
		15614
	],
	"./sq/_lib/formatRelative/index.js": [
		15614,
		7,
		15614
	],
	"./sq/_lib/localize": [
		22276,
		7,
		22276
	],
	"./sq/_lib/localize/": [
		22276,
		7,
		22276
	],
	"./sq/_lib/localize/index": [
		22276,
		7,
		22276
	],
	"./sq/_lib/localize/index.js": [
		22276,
		7,
		22276
	],
	"./sq/_lib/match": [
		67511,
		7,
		67511
	],
	"./sq/_lib/match/": [
		67511,
		7,
		67511
	],
	"./sq/_lib/match/index": [
		67511,
		7,
		67511
	],
	"./sq/_lib/match/index.js": [
		67511,
		7,
		67511
	],
	"./sq/index": [
		87488,
		7,
		87488
	],
	"./sq/index.d": [
		25570,
		9,
		25570
	],
	"./sq/index.d.ts": [
		25570,
		9,
		25570
	],
	"./sq/index.js": [
		87488,
		7,
		87488
	],
	"./sq/index.js.flow": [
		52074,
		1,
		52074
	],
	"./sq/package": [
		46696,
		3,
		46696
	],
	"./sq/package.json": [
		46696,
		3,
		46696
	],
	"./sr": [
		76286,
		9,
		34984
	],
	"./sr-Latn": [
		75633,
		9,
		75633
	],
	"./sr-Latn/": [
		75633,
		9,
		75633
	],
	"./sr-Latn/_lib/formatDistance": [
		94377,
		7,
		94377
	],
	"./sr-Latn/_lib/formatDistance/": [
		94377,
		7,
		94377
	],
	"./sr-Latn/_lib/formatDistance/index": [
		94377,
		7,
		94377
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		94377,
		7,
		94377
	],
	"./sr-Latn/_lib/formatLong": [
		1123,
		7,
		1123
	],
	"./sr-Latn/_lib/formatLong/": [
		1123,
		7,
		1123
	],
	"./sr-Latn/_lib/formatLong/index": [
		1123,
		7,
		1123
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		1123,
		7,
		1123
	],
	"./sr-Latn/_lib/formatRelative": [
		88769,
		7,
		88769
	],
	"./sr-Latn/_lib/formatRelative/": [
		88769,
		7,
		88769
	],
	"./sr-Latn/_lib/formatRelative/index": [
		88769,
		7,
		88769
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		88769,
		7,
		88769
	],
	"./sr-Latn/_lib/localize": [
		91691,
		7,
		91691
	],
	"./sr-Latn/_lib/localize/": [
		91691,
		7,
		91691
	],
	"./sr-Latn/_lib/localize/index": [
		91691,
		7,
		91691
	],
	"./sr-Latn/_lib/localize/index.js": [
		91691,
		7,
		91691
	],
	"./sr-Latn/_lib/match": [
		12403,
		7,
		12403
	],
	"./sr-Latn/_lib/match/": [
		12403,
		7,
		12403
	],
	"./sr-Latn/_lib/match/index": [
		12403,
		7,
		12403
	],
	"./sr-Latn/_lib/match/index.js": [
		12403,
		7,
		12403
	],
	"./sr-Latn/index": [
		3476,
		7,
		3476
	],
	"./sr-Latn/index.d": [
		24016,
		9,
		24016
	],
	"./sr-Latn/index.d.ts": [
		24016,
		9,
		24016
	],
	"./sr-Latn/index.js": [
		3476,
		7,
		3476
	],
	"./sr-Latn/index.js.flow": [
		46231,
		1,
		46231
	],
	"./sr-Latn/package": [
		90046,
		3,
		90046
	],
	"./sr-Latn/package.json": [
		90046,
		3,
		90046
	],
	"./sr/": [
		76286,
		9,
		34984
	],
	"./sr/_lib/formatDistance": [
		38805,
		7,
		38805
	],
	"./sr/_lib/formatDistance/": [
		38805,
		7,
		38805
	],
	"./sr/_lib/formatDistance/index": [
		38805,
		7,
		38805
	],
	"./sr/_lib/formatDistance/index.js": [
		38805,
		7,
		38805
	],
	"./sr/_lib/formatLong": [
		83976,
		7,
		83976
	],
	"./sr/_lib/formatLong/": [
		83976,
		7,
		83976
	],
	"./sr/_lib/formatLong/index": [
		83976,
		7,
		83976
	],
	"./sr/_lib/formatLong/index.js": [
		83976,
		7,
		83976
	],
	"./sr/_lib/formatRelative": [
		26793,
		7,
		26793
	],
	"./sr/_lib/formatRelative/": [
		26793,
		7,
		26793
	],
	"./sr/_lib/formatRelative/index": [
		26793,
		7,
		26793
	],
	"./sr/_lib/formatRelative/index.js": [
		26793,
		7,
		26793
	],
	"./sr/_lib/localize": [
		47878,
		7,
		47878
	],
	"./sr/_lib/localize/": [
		47878,
		7,
		47878
	],
	"./sr/_lib/localize/index": [
		47878,
		7,
		47878
	],
	"./sr/_lib/localize/index.js": [
		47878,
		7,
		47878
	],
	"./sr/_lib/match": [
		75917,
		7,
		75917
	],
	"./sr/_lib/match/": [
		75917,
		7,
		75917
	],
	"./sr/_lib/match/index": [
		75917,
		7,
		75917
	],
	"./sr/_lib/match/index.js": [
		75917,
		7,
		75917
	],
	"./sr/index": [
		58712,
		7,
		58712
	],
	"./sr/index.d": [
		99202,
		9,
		99202
	],
	"./sr/index.d.ts": [
		99202,
		9,
		99202
	],
	"./sr/index.js": [
		58712,
		7,
		58712
	],
	"./sr/index.js.flow": [
		55384,
		1,
		55384
	],
	"./sr/package": [
		44046,
		3,
		44046
	],
	"./sr/package.json": [
		44046,
		3,
		44046
	],
	"./sv": [
		98192,
		9,
		98192
	],
	"./sv/": [
		98192,
		9,
		98192
	],
	"./sv/_lib/formatDistance": [
		91157,
		7,
		91157
	],
	"./sv/_lib/formatDistance/": [
		91157,
		7,
		91157
	],
	"./sv/_lib/formatDistance/index": [
		91157,
		7,
		91157
	],
	"./sv/_lib/formatDistance/index.js": [
		91157,
		7,
		91157
	],
	"./sv/_lib/formatLong": [
		78911,
		7,
		78911
	],
	"./sv/_lib/formatLong/": [
		78911,
		7,
		78911
	],
	"./sv/_lib/formatLong/index": [
		78911,
		7,
		78911
	],
	"./sv/_lib/formatLong/index.js": [
		78911,
		7,
		78911
	],
	"./sv/_lib/formatRelative": [
		77043,
		7,
		77043
	],
	"./sv/_lib/formatRelative/": [
		77043,
		7,
		77043
	],
	"./sv/_lib/formatRelative/index": [
		77043,
		7,
		77043
	],
	"./sv/_lib/formatRelative/index.js": [
		77043,
		7,
		77043
	],
	"./sv/_lib/localize": [
		54668,
		7,
		54668
	],
	"./sv/_lib/localize/": [
		54668,
		7,
		54668
	],
	"./sv/_lib/localize/index": [
		54668,
		7,
		54668
	],
	"./sv/_lib/localize/index.js": [
		54668,
		7,
		54668
	],
	"./sv/_lib/match": [
		43670,
		7,
		43670
	],
	"./sv/_lib/match/": [
		43670,
		7,
		43670
	],
	"./sv/_lib/match/index": [
		43670,
		7,
		43670
	],
	"./sv/_lib/match/index.js": [
		43670,
		7,
		43670
	],
	"./sv/index": [
		11280,
		7,
		11280
	],
	"./sv/index.d": [
		40174,
		9,
		40174
	],
	"./sv/index.d.ts": [
		40174,
		9,
		40174
	],
	"./sv/index.js": [
		11280,
		7,
		11280
	],
	"./sv/index.js.flow": [
		86730,
		1,
		86730
	],
	"./sv/package": [
		49767,
		3,
		49767
	],
	"./sv/package.json": [
		49767,
		3,
		49767
	],
	"./ta": [
		60770,
		9,
		60770
	],
	"./ta/": [
		60770,
		9,
		60770
	],
	"./ta/_lib/formatDistance": [
		50424,
		7,
		50424
	],
	"./ta/_lib/formatDistance/": [
		50424,
		7,
		50424
	],
	"./ta/_lib/formatDistance/index": [
		50424,
		7,
		50424
	],
	"./ta/_lib/formatDistance/index.js": [
		50424,
		7,
		50424
	],
	"./ta/_lib/formatLong": [
		24729,
		7,
		24729
	],
	"./ta/_lib/formatLong/": [
		24729,
		7,
		24729
	],
	"./ta/_lib/formatLong/index": [
		24729,
		7,
		24729
	],
	"./ta/_lib/formatLong/index.js": [
		24729,
		7,
		24729
	],
	"./ta/_lib/formatRelative": [
		39334,
		7,
		39334
	],
	"./ta/_lib/formatRelative/": [
		39334,
		7,
		39334
	],
	"./ta/_lib/formatRelative/index": [
		39334,
		7,
		39334
	],
	"./ta/_lib/formatRelative/index.js": [
		39334,
		7,
		39334
	],
	"./ta/_lib/localize": [
		91086,
		7,
		91086
	],
	"./ta/_lib/localize/": [
		91086,
		7,
		91086
	],
	"./ta/_lib/localize/index": [
		91086,
		7,
		91086
	],
	"./ta/_lib/localize/index.js": [
		91086,
		7,
		91086
	],
	"./ta/_lib/match": [
		61426,
		7,
		61426
	],
	"./ta/_lib/match/": [
		61426,
		7,
		61426
	],
	"./ta/_lib/match/index": [
		61426,
		7,
		61426
	],
	"./ta/_lib/match/index.js": [
		61426,
		7,
		61426
	],
	"./ta/index": [
		45688,
		7,
		45688,
		33680
	],
	"./ta/index.d": [
		19338,
		9,
		19338
	],
	"./ta/index.d.ts": [
		19338,
		9,
		19338
	],
	"./ta/index.js": [
		45688,
		7,
		45688,
		33680
	],
	"./ta/index.js.flow": [
		9784,
		1,
		9784
	],
	"./ta/package": [
		12520,
		3,
		12520
	],
	"./ta/package.json": [
		12520,
		3,
		12520
	],
	"./te": [
		58858,
		9,
		58858
	],
	"./te/": [
		58858,
		9,
		58858
	],
	"./te/_lib/formatDistance": [
		81955,
		7,
		9745
	],
	"./te/_lib/formatDistance/": [
		81955,
		7,
		9745
	],
	"./te/_lib/formatDistance/index": [
		81955,
		7,
		9745
	],
	"./te/_lib/formatDistance/index.js": [
		81955,
		7,
		9745
	],
	"./te/_lib/formatLong": [
		47409,
		7,
		47409
	],
	"./te/_lib/formatLong/": [
		47409,
		7,
		47409
	],
	"./te/_lib/formatLong/index": [
		47409,
		7,
		47409
	],
	"./te/_lib/formatLong/index.js": [
		47409,
		7,
		47409
	],
	"./te/_lib/formatRelative": [
		72828,
		7,
		72828
	],
	"./te/_lib/formatRelative/": [
		72828,
		7,
		72828
	],
	"./te/_lib/formatRelative/index": [
		72828,
		7,
		72828
	],
	"./te/_lib/formatRelative/index.js": [
		72828,
		7,
		72828
	],
	"./te/_lib/localize": [
		38758,
		7,
		38758
	],
	"./te/_lib/localize/": [
		38758,
		7,
		38758
	],
	"./te/_lib/localize/index": [
		38758,
		7,
		38758
	],
	"./te/_lib/localize/index.js": [
		38758,
		7,
		38758
	],
	"./te/_lib/match": [
		36334,
		7,
		36334
	],
	"./te/_lib/match/": [
		36334,
		7,
		36334
	],
	"./te/_lib/match/index": [
		36334,
		7,
		36334
	],
	"./te/_lib/match/index.js": [
		36334,
		7,
		36334
	],
	"./te/index": [
		19665,
		7,
		19665
	],
	"./te/index.d": [
		47285,
		9,
		47285
	],
	"./te/index.d.ts": [
		47285,
		9,
		47285
	],
	"./te/index.js": [
		19665,
		7,
		19665
	],
	"./te/index.js.flow": [
		60893,
		1,
		60893
	],
	"./te/package": [
		49083,
		3,
		49083
	],
	"./te/package.json": [
		49083,
		3,
		49083
	],
	"./th": [
		19945,
		9,
		19945
	],
	"./th/": [
		19945,
		9,
		19945
	],
	"./th/_lib/formatDistance": [
		19485,
		7,
		39686
	],
	"./th/_lib/formatDistance/": [
		19485,
		7,
		39686
	],
	"./th/_lib/formatDistance/index": [
		19485,
		7,
		39686
	],
	"./th/_lib/formatDistance/index.js": [
		19485,
		7,
		39686
	],
	"./th/_lib/formatLong": [
		46337,
		7,
		46337
	],
	"./th/_lib/formatLong/": [
		46337,
		7,
		46337
	],
	"./th/_lib/formatLong/index": [
		46337,
		7,
		46337
	],
	"./th/_lib/formatLong/index.js": [
		46337,
		7,
		46337
	],
	"./th/_lib/formatRelative": [
		21711,
		7,
		21711
	],
	"./th/_lib/formatRelative/": [
		21711,
		7,
		21711
	],
	"./th/_lib/formatRelative/index": [
		21711,
		7,
		21711
	],
	"./th/_lib/formatRelative/index.js": [
		21711,
		7,
		21711
	],
	"./th/_lib/localize": [
		1320,
		7,
		1320
	],
	"./th/_lib/localize/": [
		1320,
		7,
		1320
	],
	"./th/_lib/localize/index": [
		1320,
		7,
		1320
	],
	"./th/_lib/localize/index.js": [
		1320,
		7,
		1320
	],
	"./th/_lib/match": [
		68919,
		7,
		68919
	],
	"./th/_lib/match/": [
		68919,
		7,
		68919
	],
	"./th/_lib/match/index": [
		68919,
		7,
		68919
	],
	"./th/_lib/match/index.js": [
		68919,
		7,
		68919
	],
	"./th/index": [
		16735,
		7,
		16735
	],
	"./th/index.d": [
		65328,
		9,
		65328
	],
	"./th/index.d.ts": [
		65328,
		9,
		65328
	],
	"./th/index.js": [
		16735,
		7,
		16735
	],
	"./th/index.js.flow": [
		69667,
		1,
		69667
	],
	"./th/package": [
		32022,
		3,
		32022
	],
	"./th/package.json": [
		32022,
		3,
		32022
	],
	"./tr": [
		8802,
		9,
		8802
	],
	"./tr/": [
		8802,
		9,
		8802
	],
	"./tr/_lib/formatDistance": [
		49791,
		7,
		49791
	],
	"./tr/_lib/formatDistance/": [
		49791,
		7,
		49791
	],
	"./tr/_lib/formatDistance/index": [
		49791,
		7,
		49791
	],
	"./tr/_lib/formatDistance/index.js": [
		49791,
		7,
		49791
	],
	"./tr/_lib/formatLong": [
		79643,
		7,
		79643
	],
	"./tr/_lib/formatLong/": [
		79643,
		7,
		79643
	],
	"./tr/_lib/formatLong/index": [
		79643,
		7,
		79643
	],
	"./tr/_lib/formatLong/index.js": [
		79643,
		7,
		79643
	],
	"./tr/_lib/formatRelative": [
		85406,
		7,
		85406
	],
	"./tr/_lib/formatRelative/": [
		85406,
		7,
		85406
	],
	"./tr/_lib/formatRelative/index": [
		85406,
		7,
		85406
	],
	"./tr/_lib/formatRelative/index.js": [
		85406,
		7,
		85406
	],
	"./tr/_lib/localize": [
		20622,
		7,
		20622
	],
	"./tr/_lib/localize/": [
		20622,
		7,
		20622
	],
	"./tr/_lib/localize/index": [
		20622,
		7,
		20622
	],
	"./tr/_lib/localize/index.js": [
		20622,
		7,
		20622
	],
	"./tr/_lib/match": [
		11194,
		7,
		11194
	],
	"./tr/_lib/match/": [
		11194,
		7,
		11194
	],
	"./tr/_lib/match/index": [
		11194,
		7,
		11194
	],
	"./tr/_lib/match/index.js": [
		11194,
		7,
		11194
	],
	"./tr/index": [
		53258,
		7,
		53258
	],
	"./tr/index.d": [
		11797,
		9,
		11797
	],
	"./tr/index.d.ts": [
		11797,
		9,
		11797
	],
	"./tr/index.js": [
		53258,
		7,
		53258
	],
	"./tr/index.js.flow": [
		12754,
		1,
		12754
	],
	"./tr/package": [
		34953,
		3,
		34953
	],
	"./tr/package.json": [
		34953,
		3,
		34953
	],
	"./types": [
		59001,
		7,
		59001
	],
	"./types.js": [
		59001,
		7,
		59001
	],
	"./ug": [
		27839,
		9,
		27839
	],
	"./ug/": [
		27839,
		9,
		27839
	],
	"./ug/_lib/formatDistance": [
		84977,
		7,
		84977
	],
	"./ug/_lib/formatDistance/": [
		84977,
		7,
		84977
	],
	"./ug/_lib/formatDistance/index": [
		84977,
		7,
		84977
	],
	"./ug/_lib/formatDistance/index.js": [
		84977,
		7,
		84977
	],
	"./ug/_lib/formatLong": [
		52408,
		7,
		52408
	],
	"./ug/_lib/formatLong/": [
		52408,
		7,
		52408
	],
	"./ug/_lib/formatLong/index": [
		52408,
		7,
		52408
	],
	"./ug/_lib/formatLong/index.js": [
		52408,
		7,
		52408
	],
	"./ug/_lib/formatRelative": [
		60839,
		7,
		60839
	],
	"./ug/_lib/formatRelative/": [
		60839,
		7,
		60839
	],
	"./ug/_lib/formatRelative/index": [
		60839,
		7,
		60839
	],
	"./ug/_lib/formatRelative/index.js": [
		60839,
		7,
		60839
	],
	"./ug/_lib/localize": [
		60386,
		7,
		60386
	],
	"./ug/_lib/localize/": [
		60386,
		7,
		60386
	],
	"./ug/_lib/localize/index": [
		60386,
		7,
		60386
	],
	"./ug/_lib/localize/index.js": [
		60386,
		7,
		60386
	],
	"./ug/_lib/match": [
		52088,
		7,
		52088
	],
	"./ug/_lib/match/": [
		52088,
		7,
		52088
	],
	"./ug/_lib/match/index": [
		52088,
		7,
		52088
	],
	"./ug/_lib/match/index.js": [
		52088,
		7,
		52088
	],
	"./ug/index": [
		13328,
		7,
		13328
	],
	"./ug/index.d": [
		22172,
		9,
		22172
	],
	"./ug/index.d.ts": [
		22172,
		9,
		22172
	],
	"./ug/index.js": [
		13328,
		7,
		13328
	],
	"./ug/index.js.flow": [
		46360,
		1,
		46360
	],
	"./ug/package": [
		65078,
		3,
		65078
	],
	"./ug/package.json": [
		65078,
		3,
		65078
	],
	"./uk": [
		56172,
		9,
		56172
	],
	"./uk/": [
		56172,
		9,
		56172
	],
	"./uk/_lib/formatDistance": [
		45614,
		7,
		45614
	],
	"./uk/_lib/formatDistance/": [
		45614,
		7,
		45614
	],
	"./uk/_lib/formatDistance/index": [
		45614,
		7,
		45614
	],
	"./uk/_lib/formatDistance/index.js": [
		45614,
		7,
		45614
	],
	"./uk/_lib/formatLong": [
		41075,
		7,
		41075
	],
	"./uk/_lib/formatLong/": [
		41075,
		7,
		41075
	],
	"./uk/_lib/formatLong/index": [
		41075,
		7,
		41075
	],
	"./uk/_lib/formatLong/index.js": [
		41075,
		7,
		41075
	],
	"./uk/_lib/formatRelative": [
		62772,
		7,
		62772
	],
	"./uk/_lib/formatRelative/": [
		62772,
		7,
		62772
	],
	"./uk/_lib/formatRelative/index": [
		62772,
		7,
		62772
	],
	"./uk/_lib/formatRelative/index.js": [
		62772,
		7,
		62772
	],
	"./uk/_lib/localize": [
		92078,
		7,
		92078
	],
	"./uk/_lib/localize/": [
		92078,
		7,
		92078
	],
	"./uk/_lib/localize/index": [
		92078,
		7,
		92078
	],
	"./uk/_lib/localize/index.js": [
		92078,
		7,
		92078
	],
	"./uk/_lib/match": [
		10586,
		7,
		10586
	],
	"./uk/_lib/match/": [
		10586,
		7,
		10586
	],
	"./uk/_lib/match/index": [
		10586,
		7,
		10586
	],
	"./uk/_lib/match/index.js": [
		10586,
		7,
		10586
	],
	"./uk/index": [
		2511,
		7,
		2511,
		22123
	],
	"./uk/index.d": [
		5445,
		9,
		5445
	],
	"./uk/index.d.ts": [
		5445,
		9,
		5445
	],
	"./uk/index.js": [
		2511,
		7,
		2511,
		22123
	],
	"./uk/index.js.flow": [
		14718,
		1,
		14718
	],
	"./uk/package": [
		61629,
		3,
		61629
	],
	"./uk/package.json": [
		61629,
		3,
		61629
	],
	"./uz": [
		78137,
		9,
		78137
	],
	"./uz/": [
		78137,
		9,
		78137
	],
	"./uz/_lib/formatDistance": [
		13838,
		7,
		13838
	],
	"./uz/_lib/formatDistance/": [
		13838,
		7,
		13838
	],
	"./uz/_lib/formatDistance/index": [
		13838,
		7,
		13838
	],
	"./uz/_lib/formatDistance/index.js": [
		13838,
		7,
		13838
	],
	"./uz/_lib/formatLong": [
		14017,
		7,
		14017
	],
	"./uz/_lib/formatLong/": [
		14017,
		7,
		14017
	],
	"./uz/_lib/formatLong/index": [
		14017,
		7,
		14017
	],
	"./uz/_lib/formatLong/index.js": [
		14017,
		7,
		14017
	],
	"./uz/_lib/formatRelative": [
		84099,
		7,
		84099
	],
	"./uz/_lib/formatRelative/": [
		84099,
		7,
		84099
	],
	"./uz/_lib/formatRelative/index": [
		84099,
		7,
		84099
	],
	"./uz/_lib/formatRelative/index.js": [
		84099,
		7,
		84099
	],
	"./uz/_lib/localize": [
		86114,
		7,
		86114
	],
	"./uz/_lib/localize/": [
		86114,
		7,
		86114
	],
	"./uz/_lib/localize/index": [
		86114,
		7,
		86114
	],
	"./uz/_lib/localize/index.js": [
		86114,
		7,
		86114
	],
	"./uz/_lib/match": [
		64310,
		7,
		64310
	],
	"./uz/_lib/match/": [
		64310,
		7,
		64310
	],
	"./uz/_lib/match/index": [
		64310,
		7,
		64310
	],
	"./uz/_lib/match/index.js": [
		64310,
		7,
		64310
	],
	"./uz/index": [
		79164,
		7,
		79164
	],
	"./uz/index.d": [
		75392,
		9,
		75392
	],
	"./uz/index.d.ts": [
		75392,
		9,
		75392
	],
	"./uz/index.js": [
		79164,
		7,
		79164
	],
	"./uz/index.js.flow": [
		42072,
		1,
		42072
	],
	"./uz/package": [
		16840,
		3,
		16840
	],
	"./uz/package.json": [
		16840,
		3,
		16840
	],
	"./vi": [
		35645,
		9,
		35645
	],
	"./vi/": [
		35645,
		9,
		35645
	],
	"./vi/_lib/formatDistance": [
		15612,
		7,
		15612
	],
	"./vi/_lib/formatDistance/": [
		15612,
		7,
		15612
	],
	"./vi/_lib/formatDistance/index": [
		15612,
		7,
		15612
	],
	"./vi/_lib/formatDistance/index.js": [
		15612,
		7,
		15612
	],
	"./vi/_lib/formatLong": [
		45178,
		7,
		45178
	],
	"./vi/_lib/formatLong/": [
		45178,
		7,
		45178
	],
	"./vi/_lib/formatLong/index": [
		45178,
		7,
		45178
	],
	"./vi/_lib/formatLong/index.js": [
		45178,
		7,
		45178
	],
	"./vi/_lib/formatRelative": [
		63712,
		7,
		63712
	],
	"./vi/_lib/formatRelative/": [
		63712,
		7,
		63712
	],
	"./vi/_lib/formatRelative/index": [
		63712,
		7,
		63712
	],
	"./vi/_lib/formatRelative/index.js": [
		63712,
		7,
		63712
	],
	"./vi/_lib/localize": [
		26158,
		7,
		26158
	],
	"./vi/_lib/localize/": [
		26158,
		7,
		26158
	],
	"./vi/_lib/localize/index": [
		26158,
		7,
		26158
	],
	"./vi/_lib/localize/index.js": [
		26158,
		7,
		26158
	],
	"./vi/_lib/match": [
		29509,
		7,
		29509
	],
	"./vi/_lib/match/": [
		29509,
		7,
		29509
	],
	"./vi/_lib/match/index": [
		29509,
		7,
		29509
	],
	"./vi/_lib/match/index.js": [
		29509,
		7,
		29509
	],
	"./vi/index": [
		30236,
		7,
		30236
	],
	"./vi/index.d": [
		64083,
		9,
		64083
	],
	"./vi/index.d.ts": [
		64083,
		9,
		64083
	],
	"./vi/index.js": [
		30236,
		7,
		30236
	],
	"./vi/index.js.flow": [
		82892,
		1,
		82892
	],
	"./vi/package": [
		12629,
		3,
		12629
	],
	"./vi/package.json": [
		12629,
		3,
		12629
	],
	"./zh-CN": [
		39204,
		9,
		39204
	],
	"./zh-CN/": [
		39204,
		9,
		39204
	],
	"./zh-CN/_lib/formatDistance": [
		25160,
		7,
		25160
	],
	"./zh-CN/_lib/formatDistance/": [
		25160,
		7,
		25160
	],
	"./zh-CN/_lib/formatDistance/index": [
		25160,
		7,
		25160
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		25160,
		7,
		25160
	],
	"./zh-CN/_lib/formatLong": [
		47066,
		7,
		47066
	],
	"./zh-CN/_lib/formatLong/": [
		47066,
		7,
		47066
	],
	"./zh-CN/_lib/formatLong/index": [
		47066,
		7,
		47066
	],
	"./zh-CN/_lib/formatLong/index.js": [
		47066,
		7,
		47066
	],
	"./zh-CN/_lib/formatRelative": [
		37963,
		7,
		37963
	],
	"./zh-CN/_lib/formatRelative/": [
		37963,
		7,
		37963
	],
	"./zh-CN/_lib/formatRelative/index": [
		37963,
		7,
		37963
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		37963,
		7,
		37963
	],
	"./zh-CN/_lib/localize": [
		33385,
		7,
		33385
	],
	"./zh-CN/_lib/localize/": [
		33385,
		7,
		33385
	],
	"./zh-CN/_lib/localize/index": [
		33385,
		7,
		33385
	],
	"./zh-CN/_lib/localize/index.js": [
		33385,
		7,
		33385
	],
	"./zh-CN/_lib/match": [
		25100,
		7,
		25100
	],
	"./zh-CN/_lib/match/": [
		25100,
		7,
		25100
	],
	"./zh-CN/_lib/match/index": [
		25100,
		7,
		25100
	],
	"./zh-CN/_lib/match/index.js": [
		25100,
		7,
		25100
	],
	"./zh-CN/index": [
		38036,
		7,
		38036
	],
	"./zh-CN/index.d": [
		2785,
		9,
		2785
	],
	"./zh-CN/index.d.ts": [
		2785,
		9,
		2785
	],
	"./zh-CN/index.js": [
		38036,
		7,
		38036
	],
	"./zh-CN/index.js.flow": [
		1442,
		1,
		1442
	],
	"./zh-CN/package": [
		55739,
		3,
		55739
	],
	"./zh-CN/package.json": [
		55739,
		3,
		55739
	],
	"./zh-TW": [
		52472,
		9,
		52472
	],
	"./zh-TW/": [
		52472,
		9,
		52472
	],
	"./zh-TW/_lib/formatDistance": [
		46555,
		7,
		46555
	],
	"./zh-TW/_lib/formatDistance/": [
		46555,
		7,
		46555
	],
	"./zh-TW/_lib/formatDistance/index": [
		46555,
		7,
		46555
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		46555,
		7,
		46555
	],
	"./zh-TW/_lib/formatLong": [
		57868,
		7,
		57868
	],
	"./zh-TW/_lib/formatLong/": [
		57868,
		7,
		57868
	],
	"./zh-TW/_lib/formatLong/index": [
		57868,
		7,
		57868
	],
	"./zh-TW/_lib/formatLong/index.js": [
		57868,
		7,
		57868
	],
	"./zh-TW/_lib/formatRelative": [
		8796,
		7,
		8796
	],
	"./zh-TW/_lib/formatRelative/": [
		8796,
		7,
		8796
	],
	"./zh-TW/_lib/formatRelative/index": [
		8796,
		7,
		8796
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		8796,
		7,
		8796
	],
	"./zh-TW/_lib/localize": [
		92422,
		7,
		92422
	],
	"./zh-TW/_lib/localize/": [
		92422,
		7,
		92422
	],
	"./zh-TW/_lib/localize/index": [
		92422,
		7,
		92422
	],
	"./zh-TW/_lib/localize/index.js": [
		92422,
		7,
		92422
	],
	"./zh-TW/_lib/match": [
		28015,
		7,
		28015
	],
	"./zh-TW/_lib/match/": [
		28015,
		7,
		28015
	],
	"./zh-TW/_lib/match/index": [
		28015,
		7,
		28015
	],
	"./zh-TW/_lib/match/index.js": [
		28015,
		7,
		28015
	],
	"./zh-TW/index": [
		70305,
		7,
		70305
	],
	"./zh-TW/index.d": [
		5674,
		9,
		5674
	],
	"./zh-TW/index.d.ts": [
		5674,
		9,
		5674
	],
	"./zh-TW/index.js": [
		70305,
		7,
		70305
	],
	"./zh-TW/index.js.flow": [
		49014,
		1,
		49014
	],
	"./zh-TW/package": [
		25343,
		3,
		25343
	],
	"./zh-TW/package.json": [
		25343,
		3,
		25343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 58588;
module.exports = webpackAsyncContext;